(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global,setImmediate){(function (){
/*! @vimeo/player v2.26.0 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory()));
}(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _regeneratorRuntime() {
    _regeneratorRuntime = function () {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function (obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function (method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
              return next.value = undefined, next.done = !0, next;
            };
          return next.next = next;
        }
      }
      return {
        next: doneResult
      };
    }
    function doneResult() {
      return {
        value: undefined,
        done: !0
      };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key = keys.pop();
          if (key in object) return next.value = key, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      },
      stop: function () {
        this.done = !0;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function (record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      catch: function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  /**
   * @module lib/functions
   */

  /**
   * Check to see this is a node environment.
   * @type {Boolean}
   */
  /* global global */
  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';

  /**
   * Get the name of the method for a given getter or setter.
   *
   * @param {string} prop The name of the property.
   * @param {string} type Either “get” or “set”.
   * @return {string}
   */
  function getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) {
      return prop;
    }
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
  }

  /**
   * Check to see if the object is a DOM Element.
   *
   * @param {*} element The object to check.
   * @return {boolean}
   */
  function isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
  }

  /**
   * Check to see whether the value is a number.
   *
   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
   * @param {*} value The value to check.
   * @param {boolean} integer Check if the value is an integer.
   * @return {boolean}
   */
  function isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
  }

  /**
   * Check to see if the URL is a Vimeo url.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */
  function isVimeoUrl(url) {
    return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(url);
  }

  /**
   * Check to see if the URL is for a Vimeo embed.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */
  function isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
    return expr.test(url);
  }
  function getOembedDomain(url) {
    var match = (url || '').match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
    var domain = (match && match[1] || '').replace('player.', '');
    var customDomains = ['.videoji.hk', '.vimeo.work', '.videoji.cn'];
    for (var _i = 0, _customDomains = customDomains; _i < _customDomains.length; _i++) {
      var customDomain = _customDomains[_i];
      if (domain.endsWith(customDomain)) {
        return domain;
      }
    }
    return 'vimeo.com';
  }

  /**
   * Get the Vimeo URL from an element.
   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
   *
   * @param {object} oEmbedParameters The oEmbed parameters.
   * @return {string}
   */
  function getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) {
      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    }
    if (isInteger(idOrUrl)) {
      return "https://vimeo.com/".concat(idOrUrl);
    }
    if (isVimeoUrl(idOrUrl)) {
      return idOrUrl.replace('http:', 'https:');
    }
    if (id) {
      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    }
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
  }

  /* eslint-disable max-params */
  /**
   * A utility method for attaching and detaching event handlers
   *
   * @param {EventTarget} target
   * @param {string | string[]} eventName
   * @param {function} callback
   * @param {'addEventListener' | 'on'} onName
   * @param {'removeEventListener' | 'off'} offName
   * @return {{cancel: (function(): void)}}
   */
  var subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
    var eventNames = typeof eventName === 'string' ? [eventName] : eventName;
    eventNames.forEach(function (evName) {
      target[onName](evName, callback);
    });
    return {
      cancel: function cancel() {
        return eventNames.forEach(function (evName) {
          return target[offName](evName, callback);
        });
      }
    };
  };

  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /*!
   * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
   * https://github.com/polygonplanet/weakmap-polyfill
   * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
   * @license MIT
   */

  (function (self) {

    if (self.WeakMap) {
      return;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function () {
      try {
        // Avoid IE8's broken Object.defineProperty
        return Object.defineProperty({}, 'x', {
          value: 1
        }).x === 1;
      } catch (e) {}
    }();
    var defineProperty = function (object, name, value) {
      if (hasDefine) {
        Object.defineProperty(object, name, {
          configurable: true,
          writable: true,
          value: value
        });
      } else {
        object[name] = value;
      }
    };
    self.WeakMap = function () {
      // ECMA-262 23.3 WeakMap Objects
      function WeakMap() {
        if (this === void 0) {
          throw new TypeError("Constructor WeakMap requires 'new'");
        }
        defineProperty(this, '_id', genId('_WeakMap'));

        // ECMA-262 23.3.1.1 WeakMap([iterable])
        if (arguments.length > 0) {
          // Currently, WeakMap `iterable` argument is not supported
          throw new TypeError('WeakMap iterable is not supported');
        }
      }

      // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
      defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');
        if (!isObject(key)) {
          return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          delete key[this._id];
          return true;
        }
        return false;
      });

      // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
      defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');
        if (!isObject(key)) {
          return void 0;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          return entry[1];
        }
        return void 0;
      });

      // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
      defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');
        if (!isObject(key)) {
          return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          return true;
        }
        return false;
      });

      // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
      defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');
        if (!isObject(key)) {
          throw new TypeError('Invalid value used as weak map key');
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          entry[1] = value;
          return this;
        }
        defineProperty(key, this._id, [key, value]);
        return this;
      });
      function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
      }
      function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
      }
      function rand() {
        return Math.random().toString().substring(2);
      }
      defineProperty(WeakMap, '_polyfill', true);
      return WeakMap;
    }();
    function isObject(x) {
      return Object(x) === x;
    }
  })(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

  var npo_src = createCommonjsModule(function (module) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */

  (function UMD(name, context, definition) {
    // special form of UMD for polyfilling across evironments
    context[name] = context[name] || definition();
    if ( module.exports) {
      module.exports = context[name];
    }
  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

    var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
        return setImmediate(fn);
      } : setTimeout;

    // dammit, IE8.
    try {
      Object.defineProperty({}, "x", {});
      builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
          value: val,
          writable: true,
          configurable: config !== false
        });
      };
    } catch (err) {
      builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
      };
    }

    // Note: using a queue instead of array for efficiency
    scheduling_queue = function Queue() {
      var first, last, item;
      function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
      }
      return {
        add: function add(fn, self) {
          item = new Item(fn, self);
          if (last) {
            last.next = item;
          } else {
            first = item;
          }
          last = item;
          item = void 0;
        },
        drain: function drain() {
          var f = first;
          first = last = cycle = void 0;
          while (f) {
            f.fn.call(f.self);
            f = f.next;
          }
        }
      };
    }();
    function schedule(fn, self) {
      scheduling_queue.add(fn, self);
      if (!cycle) {
        cycle = timer(scheduling_queue.drain);
      }
    }

    // promise duck typing
    function isThenable(o) {
      var _then,
        o_type = typeof o;
      if (o != null && (o_type == "object" || o_type == "function")) {
        _then = o.then;
      }
      return typeof _then == "function" ? _then : false;
    }
    function notify() {
      for (var i = 0; i < this.chain.length; i++) {
        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
      }
      this.chain.length = 0;
    }

    // NOTE: This is a separate function to isolate
    // the `try..catch` so that other code can be
    // optimized better
    function notifyIsolated(self, cb, chain) {
      var ret, _then;
      try {
        if (cb === false) {
          chain.reject(self.msg);
        } else {
          if (cb === true) {
            ret = self.msg;
          } else {
            ret = cb.call(void 0, self.msg);
          }
          if (ret === chain.promise) {
            chain.reject(TypeError("Promise-chain cycle"));
          } else if (_then = isThenable(ret)) {
            _then.call(ret, chain.resolve, chain.reject);
          } else {
            chain.resolve(ret);
          }
        }
      } catch (err) {
        chain.reject(err);
      }
    }
    function resolve(msg) {
      var _then,
        self = this;

      // already triggered?
      if (self.triggered) {
        return;
      }
      self.triggered = true;

      // unwrap
      if (self.def) {
        self = self.def;
      }
      try {
        if (_then = isThenable(msg)) {
          schedule(function () {
            var def_wrapper = new MakeDefWrapper(self);
            try {
              _then.call(msg, function $resolve$() {
                resolve.apply(def_wrapper, arguments);
              }, function $reject$() {
                reject.apply(def_wrapper, arguments);
              });
            } catch (err) {
              reject.call(def_wrapper, err);
            }
          });
        } else {
          self.msg = msg;
          self.state = 1;
          if (self.chain.length > 0) {
            schedule(notify, self);
          }
        }
      } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
      }
    }
    function reject(msg) {
      var self = this;

      // already triggered?
      if (self.triggered) {
        return;
      }
      self.triggered = true;

      // unwrap
      if (self.def) {
        self = self.def;
      }
      self.msg = msg;
      self.state = 2;
      if (self.chain.length > 0) {
        schedule(notify, self);
      }
    }
    function iteratePromises(Constructor, arr, resolver, rejecter) {
      for (var idx = 0; idx < arr.length; idx++) {
        (function IIFE(idx) {
          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
          }, rejecter);
        })(idx);
      }
    }
    function MakeDefWrapper(self) {
      this.def = self;
      this.triggered = false;
    }
    function MakeDef(self) {
      this.promise = self;
      this.state = 0;
      this.triggered = false;
      this.chain = [];
      this.msg = void 0;
    }
    function Promise(executor) {
      if (typeof executor != "function") {
        throw TypeError("Not a function");
      }
      if (this.__NPO__ !== 0) {
        throw TypeError("Not a promise");
      }

      // instance shadowing the inherited "brand"
      // to signal an already "initialized" promise
      this.__NPO__ = 1;
      var def = new MakeDef(this);
      this["then"] = function then(success, failure) {
        var o = {
          success: typeof success == "function" ? success : true,
          failure: typeof failure == "function" ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
          o.resolve = resolve;
          o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) {
          schedule(notify, def);
        }
        return o.promise;
      };
      this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
      };
      try {
        executor.call(void 0, function publicResolve(msg) {
          resolve.call(def, msg);
        }, function publicReject(msg) {
          reject.call(def, msg);
        });
      } catch (err) {
        reject.call(def, err);
      }
    }
    var PromisePrototype = builtInProp({}, "constructor", Promise, /*configurable=*/false);

    // Note: Android 4 cannot use `Object.defineProperty(..)` here
    Promise.prototype = PromisePrototype;

    // built-in "brand" to signal an "uninitialized" promise
    builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/false);
    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
      var Constructor = this;

      // spec mandated checks
      // note: best "isPromise" check that's practical for now
      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
        return msg;
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        resolve(msg);
      });
    });
    builtInProp(Promise, "reject", function Promise$reject(msg) {
      return new this(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        reject(msg);
      });
    });
    builtInProp(Promise, "all", function Promise$all(arr) {
      var Constructor = this;

      // spec mandated checks
      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }
      if (arr.length === 0) {
        return Constructor.resolve([]);
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        var len = arr.length,
          msgs = Array(len),
          count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          msgs[idx] = msg;
          if (++count === len) {
            resolve(msgs);
          }
        }, reject);
      });
    });
    builtInProp(Promise, "race", function Promise$race(arr) {
      var Constructor = this;

      // spec mandated checks
      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          resolve(msg);
        }, reject);
      });
    });
    return Promise;
  });
  });

  /**
   * @module lib/callbacks
   */

  var callbackMap = new WeakMap();

  /**
   * Store a callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
   *        The callback to call or an object with resolve and reject functions for a promise.
   * @return {void}
   */
  function storeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) {
      playerCallbacks[name] = [];
    }
    playerCallbacks[name].push(callback);
    callbackMap.set(player.element, playerCallbacks);
  }

  /**
   * Get the callbacks for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @return {function[]}
   */
  function getCallbacks(player, name) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
  }

  /**
   * Remove a stored callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @param {function} [callback] The specific callback to remove.
   * @return {boolean} Was this the last callback?
   */
  function removeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) {
      return true;
    }

    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
      playerCallbacks[name] = [];
      callbackMap.set(player.element, playerCallbacks);
      return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) {
      playerCallbacks[name].splice(index, 1);
    }
    callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
  }

  /**
   * Return the first stored callback for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @return {function} The callback, or false if there were none
   */
  function shiftCallbacks(player, name) {
    var playerCallbacks = getCallbacks(player, name);
    if (playerCallbacks.length < 1) {
      return false;
    }
    var callback = playerCallbacks.shift();
    removeCallback(player, name, callback);
    return callback;
  }

  /**
   * Move callbacks associated with an element to another element.
   *
   * @param {HTMLElement} oldElement The old element.
   * @param {HTMLElement} newElement The new element.
   * @return {void}
   */
  function swapCallbacks(oldElement, newElement) {
    var playerCallbacks = callbackMap.get(oldElement);
    callbackMap.set(newElement, playerCallbacks);
    callbackMap.delete(oldElement);
  }

  /**
   * @module lib/postmessage
   */

  /**
   * Parse a message received from postMessage.
   *
   * @param {*} data The data received from postMessage.
   * @return {object}
   */
  function parseMessageData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
      }
    }
    return data;
  }

  /**
   * Post a message to the specified target.
   *
   * @param {Player} player The player object to use.
   * @param {string} method The API method to call.
   * @param {object} params The parameters to send to the player.
   * @return {void}
   */
  function postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
      return;
    }
    var message = {
      method: method
    };
    if (params !== undefined) {
      message.value = params;
    }

    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    if (ieVersion >= 8 && ieVersion < 10) {
      message = JSON.stringify(message);
    }
    player.element.contentWindow.postMessage(message, player.origin);
  }

  /**
   * Parse the data received from a message event.
   *
   * @param {Player} player The player that received the message.
   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
   * @return {void}
   */
  function processData(player, data) {
    data = parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
      if (data.event === 'error') {
        var promises = getCallbacks(player, data.data.method);
        promises.forEach(function (promise) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          promise.reject(error);
          removeCallback(player, data.data.method, promise);
        });
      }
      callbacks = getCallbacks(player, "event:".concat(data.event));
      param = data.data;
    } else if (data.method) {
      var callback = shiftCallbacks(player, data.method);
      if (callback) {
        callbacks.push(callback);
        param = data.value;
      }
    }
    callbacks.forEach(function (callback) {
      try {
        if (typeof callback === 'function') {
          callback.call(player, param);
          return;
        }
        callback.resolve(param);
      } catch (e) {
        // empty
      }
    });
  }

  /**
   * @module lib/embed
   */
  var oEmbedParameters = ['airplay', 'audio_tracks', 'audiotrack', 'autopause', 'autoplay', 'background', 'byline', 'cc', 'chapter_id', 'chapters', 'chromecast', 'color', 'colors', 'controls', 'dnt', 'end_time', 'fullscreen', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'play_button_position', 'playsinline', 'portrait', 'progress_bar', 'quality_selector', 'responsive', 'skipping_forward', 'speed', 'start_time', 'texttrack', 'title', 'transcript', 'transparent', 'unmute_button', 'url', 'vimeo_logo', 'volume', 'watch_full_video', 'width'];

  /**
   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
   *
   * @param {HTMLElement} element The element.
   * @param {Object} [defaults={}] The default values to use.
   * @return {Object<string, string>}
   */
  function getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return oEmbedParameters.reduce(function (params, param) {
      var value = element.getAttribute("data-vimeo-".concat(param));
      if (value || value === '') {
        params[param] = value === '' ? 1 : value;
      }
      return params;
    }, defaults);
  }

  /**
   * Create an embed from oEmbed data inside an element.
   *
   * @param {object} data The oEmbed data.
   * @param {HTMLElement} element The element to put the iframe in.
   * @return {HTMLIFrameElement} The iframe embed.
   */
  function createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) {
      throw new TypeError('An element must be provided');
    }
    if (element.getAttribute('data-vimeo-initialized') !== null) {
      return element.querySelector('iframe');
    }
    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
  }

  /**
   * Make an oEmbed call for the specified URL.
   *
   * @param {string} videoUrl The vimeo.com url for the video.
   * @param {Object} [params] Parameters to pass to oEmbed.
   * @param {HTMLElement} element The element.
   * @return {Promise}
   */
  function getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      if (!isVimeoUrl(videoUrl)) {
        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
      }
      var domain = getOembedDomain(videoUrl);
      var url = "https://".concat(domain, "/api/oembed.json?url=").concat(encodeURIComponent(videoUrl));
      for (var param in params) {
        if (params.hasOwnProperty(param)) {
          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        }
      }
      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onload = function () {
        if (xhr.status === 404) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
          return;
        }
        if (xhr.status === 403) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }
        try {
          var json = JSON.parse(xhr.responseText);
          // Check api response for 403 on oembed
          if (json.domain_status_code === 403) {
            // We still want to create the embed to give users visual feedback
            createEmbed(json, element);
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }
          resolve(json);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = function () {
        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
      };
      xhr.send();
    });
  }

  /**
   * Initialize all embeds within a specific element
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error creating an embed: ".concat(error));
      }
    };
    elements.forEach(function (element) {
      try {
        // Skip any that have data-vimeo-defer
        if (element.getAttribute('data-vimeo-defer') !== null) {
          return;
        }
        var params = getOEmbedParameters(element);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          return createEmbed(data, element);
        }).catch(handleError);
      } catch (error) {
        handleError(error);
      }
    });
  }

  /**
   * Resize embeds when messaged by the player.
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) {
      return;
    }
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }

      // 'spacechange' is fired only on embeds with cards
      if (!event.data || event.data.event !== 'spacechange') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow !== event.source) {
          continue;
        }

        // Change padding-bottom of the enclosing div to accommodate
        // card carousel without distorting aspect ratio
        var space = iframes[i].parentElement;
        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        break;
      }
    };
    window.addEventListener('message', onMessage);
  }

  /**
   * Add chapters to existing metadata for Google SEO
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) {
      return;
    }
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }
      var data = parseMessageData(event.data);
      if (!data || data.event !== 'ready') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];

        // Initiate appendVideoMetadata if iframe is a Vimeo embed
        var isValidMessageSource = iframe.contentWindow === event.source;
        if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
          var player = new Player(iframe);
          player.callMethod('appendVideoMetadata', window.location.href);
        }
      }
    };
    window.addEventListener('message', onMessage);
  }

  /**
   * Seek to time indicated by vimeo_t query parameter if present in URL
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) {
      return;
    }
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error getting video Id: ".concat(error));
      }
    };
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }
      var data = parseMessageData(event.data);
      if (!data || data.event !== 'ready') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      var _loop = function _loop() {
        var iframe = iframes[i];
        var isValidMessageSource = iframe.contentWindow === event.source;
        if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
          var player = new Player(iframe);
          player.getVideoId().then(function (videoId) {
            var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
            if (matches && matches[1]) {
              var sec = decodeURI(matches[1]);
              player.setCurrentTime(sec);
            }
            return;
          }).catch(handleError);
        }
      };
      for (var i = 0; i < iframes.length; i++) {
        _loop();
      }
    };
    window.addEventListener('message', onMessage);
  }

  /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */

  function initializeScreenfull() {
    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
      // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
      // Old WebKit
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};
      for (; i < l; i++) {
        val = fnMap[i];
        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }
          return ret;
        }
      }
      return false;
    }();
    var eventNameMap = {
      fullscreenchange: fn.fullscreenchange,
      fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(element) {
        return new Promise(function (resolve, reject) {
          var onFullScreenEntered = function onFullScreenEntered() {
            screenfull.off('fullscreenchange', onFullScreenEntered);
            resolve();
          };
          screenfull.on('fullscreenchange', onFullScreenEntered);
          element = element || document.documentElement;
          var returnPromise = element[fn.requestFullscreen]();
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        });
      },
      exit: function exit() {
        return new Promise(function (resolve, reject) {
          if (!screenfull.isFullscreen) {
            resolve();
            return;
          }
          var onFullScreenExit = function onFullScreenExit() {
            screenfull.off('fullscreenchange', onFullScreenExit);
            resolve();
          };
          screenfull.on('fullscreenchange', onFullScreenExit);
          var returnPromise = document[fn.exitFullscreen]();
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        });
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document.addEventListener(eventName, callback);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document.removeEventListener(eventName, callback);
        }
      }
    };
    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });
    return screenfull;
  }

  /** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */
  /** @typedef {import('./timing-object.types').TimingObject} TimingObject */
  /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
  /** @typedef {(msg: string) => any} Logger */
  /** @typedef {import('timing-object.types').TConnectionState} TConnectionState */

  /**
   * @type {TimingSrcConnectorOptions}
   *
   * For details on these properties and their effects, see the typescript definition referenced above.
   */
  var defaultOptions = {
    role: 'viewer',
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
  };

  /**
   * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
   *
   * Proposed spec: https://webtiming.github.io/timingobject/
   * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
   * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
   *
   * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
   *
   * There are 5 general responsibilities in TimingSrcConnector:
   *
   * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
   * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
   * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
   * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
   * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
   */
  var TimingSrcConnector = /*#__PURE__*/function (_EventTarget) {
    _inherits(TimingSrcConnector, _EventTarget);
    var _super = _createSuper(TimingSrcConnector);
    /**
     * @param {PlayerControls} player
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     * @param {Logger} logger
     */
    function TimingSrcConnector(_player, timingObject) {
      var _this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var logger = arguments.length > 3 ? arguments[3] : undefined;
      _classCallCheck(this, TimingSrcConnector);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "logger", void 0);
      _defineProperty(_assertThisInitialized(_this), "speedAdjustment", 0);
      /**
       * @param {PlayerControls} player
       * @param {number} newAdjustment
       * @return {Promise<void>}
       */
      _defineProperty(_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
          var newPlaybackRate;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.speedAdjustment === newAdjustment)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return player.getPlaybackRate();
              case 4:
                _context.t0 = _context.sent;
                _context.t1 = _this.speedAdjustment;
                _context.t2 = _context.t0 - _context.t1;
                _context.t3 = newAdjustment;
                newPlaybackRate = _context.t2 + _context.t3;
                _this.log("New playbackRate:  ".concat(newPlaybackRate));
                _context.next = 12;
                return player.setPlaybackRate(newPlaybackRate);
              case 12:
                _this.speedAdjustment = newAdjustment;
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      _this.logger = logger;
      _this.init(timingObject, _player, _objectSpread2(_objectSpread2({}, defaultOptions), options));
      return _this;
    }
    _createClass(TimingSrcConnector, [{
      key: "disconnect",
      value: function disconnect() {
        this.dispatchEvent(new Event('disconnect'));
      }

      /**
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {Promise<void>}
       */
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
          var _this2 = this;
          var playerUpdater, positionSync, timingObjectUpdater;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.waitForTOReadyState(timingObject, 'open');
              case 2:
                if (!(options.role === 'viewer')) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 5;
                return this.updatePlayer(timingObject, player, options);
              case 5:
                playerUpdater = subscribe(timingObject, 'change', function () {
                  return _this2.updatePlayer(timingObject, player, options);
                });
                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                this.addEventListener('disconnect', function () {
                  positionSync.cancel();
                  playerUpdater.cancel();
                });
                _context2.next = 14;
                break;
              case 10:
                _context2.next = 12;
                return this.updateTimingObject(timingObject, player);
              case 12:
                timingObjectUpdater = subscribe(player, ['seeked', 'play', 'pause', 'ratechange'], function () {
                  return _this2.updateTimingObject(timingObject, player);
                }, 'on', 'off');
                this.addEventListener('disconnect', function () {
                  return timingObjectUpdater.cancel();
                });
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function init(_x3, _x4, _x5) {
          return _init.apply(this, arguments);
        }
        return init;
      }()
      /**
       * Sets the TimingObject's state to reflect that of the player
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @return {Promise<void>}
       */
    }, {
      key: "updateTimingObject",
      value: function () {
        var _updateTimingObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(timingObject, player) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = timingObject;
                _context3.next = 3;
                return player.getCurrentTime();
              case 3:
                _context3.t1 = _context3.sent;
                _context3.next = 6;
                return player.getPaused();
              case 6:
                if (!_context3.sent) {
                  _context3.next = 10;
                  break;
                }
                _context3.t2 = 0;
                _context3.next = 13;
                break;
              case 10:
                _context3.next = 12;
                return player.getPlaybackRate();
              case 12:
                _context3.t2 = _context3.sent;
              case 13:
                _context3.t3 = _context3.t2;
                _context3.t4 = {
                  position: _context3.t1,
                  velocity: _context3.t3
                };
                _context3.t0.update.call(_context3.t0, _context3.t4);
              case 16:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function updateTimingObject(_x6, _x7) {
          return _updateTimingObject.apply(this, arguments);
        }
        return updateTimingObject;
      }()
      /**
       * Sets the player's timing state to reflect that of the TimingObject
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {Promise<void>}
       */
    }, {
      key: "updatePlayer",
      value: function () {
        var _updatePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
          var _timingObject$query, position, velocity;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                if (typeof position === 'number') {
                  player.setCurrentTime(position);
                }
                if (!(typeof velocity === 'number')) {
                  _context5.next = 25;
                  break;
                }
                if (!(velocity === 0)) {
                  _context5.next = 11;
                  break;
                }
                _context5.next = 6;
                return player.getPaused();
              case 6:
                _context5.t0 = _context5.sent;
                if (!(_context5.t0 === false)) {
                  _context5.next = 9;
                  break;
                }
                player.pause();
              case 9:
                _context5.next = 25;
                break;
              case 11:
                if (!(velocity > 0)) {
                  _context5.next = 25;
                  break;
                }
                _context5.next = 14;
                return player.getPaused();
              case 14:
                _context5.t1 = _context5.sent;
                if (!(_context5.t1 === true)) {
                  _context5.next = 19;
                  break;
                }
                _context5.next = 18;
                return player.play().catch( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(err) {
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(err.name === 'NotAllowedError' && options.autoPlayMuted)) {
                            _context4.next = 5;
                            break;
                          }
                          _context4.next = 3;
                          return player.setMuted(true);
                        case 3:
                          _context4.next = 5;
                          return player.play().catch(function (err2) {
                            return console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2);
                          });
                        case 5:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x11) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 18:
                this.updatePlayer(timingObject, player, options);
              case 19:
                _context5.next = 21;
                return player.getPlaybackRate();
              case 21:
                _context5.t2 = _context5.sent;
                _context5.t3 = velocity;
                if (!(_context5.t2 !== _context5.t3)) {
                  _context5.next = 25;
                  break;
                }
                player.setPlaybackRate(velocity);
              case 25:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function updatePlayer(_x8, _x9, _x10) {
          return _updatePlayer.apply(this, arguments);
        }
        return updatePlayer;
      }()
      /**
       * Since video players do not play with 100% time precision, we need to closely monitor
       * our player to be sure it remains in sync with the TimingObject.
       *
       * If out of sync, we use the current conditions and the options provided to determine
       * whether to re-sync via setting currentTime or adjusting the playbackRate
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {{cancel: (function(): void)}}
       */
    }, {
      key: "maintainPlaybackPosition",
      value: function maintainPlaybackPosition(timingObject, player, options) {
        var _this3 = this;
        var allowedDrift = options.allowedDrift,
          maxAllowedDrift = options.maxAllowedDrift,
          minCheckInterval = options.minCheckInterval,
          maxRateAdjustment = options.maxRateAdjustment,
          maxTimeToCatchUp = options.maxTimeToCatchUp;
        var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
        var check = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var diff, diffAbs, min, max, adjustment;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.t0 = timingObject.query().velocity === 0;
                  if (_context6.t0) {
                    _context6.next = 6;
                    break;
                  }
                  _context6.next = 4;
                  return player.getPaused();
                case 4:
                  _context6.t1 = _context6.sent;
                  _context6.t0 = _context6.t1 === true;
                case 6:
                  if (!_context6.t0) {
                    _context6.next = 8;
                    break;
                  }
                  return _context6.abrupt("return");
                case 8:
                  _context6.t2 = timingObject.query().position;
                  _context6.next = 11;
                  return player.getCurrentTime();
                case 11:
                  _context6.t3 = _context6.sent;
                  diff = _context6.t2 - _context6.t3;
                  diffAbs = Math.abs(diff);
                  _this3.log("Drift: ".concat(diff));
                  if (!(diffAbs > maxAllowedDrift)) {
                    _context6.next = 22;
                    break;
                  }
                  _context6.next = 18;
                  return _this3.adjustSpeed(player, 0);
                case 18:
                  player.setCurrentTime(timingObject.query().position);
                  _this3.log('Resync by currentTime');
                  _context6.next = 29;
                  break;
                case 22:
                  if (!(diffAbs > allowedDrift)) {
                    _context6.next = 29;
                    break;
                  }
                  min = diffAbs / maxTimeToCatchUp;
                  max = maxRateAdjustment;
                  adjustment = min < max ? (max - min) / 2 : max;
                  _context6.next = 28;
                  return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                case 28:
                  _this3.log('Resync by playbackRate');
                case 29:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          return function check() {
            return _ref3.apply(this, arguments);
          };
        }();
        var interval = setInterval(function () {
          return check();
        }, syncInterval);
        return {
          cancel: function cancel() {
            return clearInterval(interval);
          }
        };
      }

      /**
       * @param {string} msg
       */
    }, {
      key: "log",
      value: function log(msg) {
        var _this$logger;
        (_this$logger = this.logger) === null || _this$logger === void 0 ? void 0 : _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
      }
    }, {
      key: "waitForTOReadyState",
      value:
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function waitForTOReadyState(timingObject, state) {
        return new Promise(function (resolve) {
          var check = function check() {
            if (timingObject.readyState === state) {
              resolve();
            } else {
              timingObject.addEventListener('readystatechange', check, {
                once: true
              });
            }
          };
          check();
        });
      }
    }]);
    return TimingSrcConnector;
  }( /*#__PURE__*/_wrapNativeSuper(EventTarget));

  var playerMap = new WeakMap();
  var readyMap = new WeakMap();
  var screenfull = {};
  var Player = /*#__PURE__*/function () {
    /**
     * Create a Player.
     *
     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
     *        player iframe, and id, or a jQuery object.
     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
     * @return {Player}
     */
    function Player(element) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Player);
      /* global jQuery */
      if (window.jQuery && element instanceof jQuery) {
        if (element.length > 1 && window.console && console.warn) {
          console.warn('A jQuery object with multiple elements was passed, using the first element.');
        }
        element = element[0];
      }

      // Find an element by ID
      if (typeof document !== 'undefined' && typeof element === 'string') {
        element = document.getElementById(element);
      }

      // Not an element!
      if (!isDomElement(element)) {
        throw new TypeError('You must pass either a valid element or a valid id.');
      }

      // Already initialized an embed in this div, so grab the iframe
      if (element.nodeName !== 'IFRAME') {
        var iframe = element.querySelector('iframe');
        if (iframe) {
          element = iframe;
        }
      }

      // iframe url is not a Vimeo url
      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
        throw new Error('The player element passed isn’t a Vimeo embed.');
      }

      // If there is already a player object in the map, return that
      if (playerMap.has(element)) {
        return playerMap.get(element);
      }
      this._window = element.ownerDocument.defaultView;
      this.element = element;
      this.origin = '*';
      var readyPromise = new npo_src(function (resolve, reject) {
        _this._onMessage = function (event) {
          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
            return;
          }
          if (_this.origin === '*') {
            _this.origin = event.origin;
          }
          var data = parseMessageData(event.data);
          var isError = data && data.event === 'error';
          var isReadyError = isError && data.data && data.data.method === 'ready';
          if (isReadyError) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            reject(error);
            return;
          }
          var isReadyEvent = data && data.event === 'ready';
          var isPingResponse = data && data.method === 'ping';
          if (isReadyEvent || isPingResponse) {
            _this.element.setAttribute('data-ready', 'true');
            resolve();
            return;
          }
          processData(_this, data);
        };
        _this._window.addEventListener('message', _this._onMessage);
        if (_this.element.nodeName !== 'IFRAME') {
          var params = getOEmbedParameters(element, options);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            var iframe = createEmbed(data, element);
            // Overwrite element with the new iframe,
            // but store reference to the original element
            _this.element = iframe;
            _this._originalElement = element;
            swapCallbacks(element, iframe);
            playerMap.set(_this.element, _this);
            return data;
          }).catch(reject);
        }
      });

      // Store a copy of this Player in the map
      readyMap.set(this, readyPromise);
      playerMap.set(this.element, this);

      // Send a ping to the iframe so the ready promise will be resolved if
      // the player is already ready.
      if (this.element.nodeName === 'IFRAME') {
        postMessage(this, 'ping');
      }
      if (screenfull.isEnabled) {
        var exitFullscreen = function exitFullscreen() {
          return screenfull.exit();
        };
        this.fullscreenchangeHandler = function () {
          if (screenfull.isFullscreen) {
            storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } else {
            removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          }
          // eslint-disable-next-line
          _this.ready().then(function () {
            postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
          });
        };
        screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
      }
      return this;
    }

    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {Object} [args={}] Arguments to send via postMessage.
     * @return {Promise}
     */
    _createClass(Player, [{
      key: "callMethod",
      value: function callMethod(name) {
        var _this2 = this;
        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new npo_src(function (resolve, reject) {
          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this2.ready().then(function () {
            storeCallback(_this2, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this2, name, args);
          }).catch(reject);
        });
      }

      /**
       * Get a promise for the value of a player property.
       *
       * @param {string} name The property name
       * @return {Promise}
       */
    }, {
      key: "get",
      value: function get(name) {
        var _this3 = this;
        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'get');

          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this3.ready().then(function () {
            storeCallback(_this3, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this3, name);
          }).catch(reject);
        });
      }

      /**
       * Get a promise for setting the value of a player property.
       *
       * @param {string} name The API method to call.
       * @param {mixed} value The value to set.
       * @return {Promise}
       */
    }, {
      key: "set",
      value: function set(name, value) {
        var _this4 = this;
        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'set');
          if (value === undefined || value === null) {
            throw new TypeError('There must be a value to set.');
          }

          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this4.ready().then(function () {
            storeCallback(_this4, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this4, name, value);
          }).catch(reject);
        });
      }

      /**
       * Add an event listener for the specified event. Will call the
       * callback with a single parameter, `data`, that contains the data for
       * that event.
       *
       * @param {string} eventName The name of the event.
       * @param {function(*)} callback The function to call when the event fires.
       * @return {void}
       */
    }, {
      key: "on",
      value: function on(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }
        if (!callback) {
          throw new TypeError('You must pass a callback function.');
        }
        if (typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }
        var callbacks = getCallbacks(this, "event:".concat(eventName));
        if (callbacks.length === 0) {
          this.callMethod('addEventListener', eventName).catch(function () {
            // Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
        storeCallback(this, "event:".concat(eventName), callback);
      }

      /**
       * Remove an event listener for the specified event. Will remove all
       * listeners for that event if a `callback` isn’t passed, or only that
       * specific callback if it is passed.
       *
       * @param {string} eventName The name of the event.
       * @param {function} [callback] The specific callback to remove.
       * @return {void}
       */
    }, {
      key: "off",
      value: function off(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }
        if (callback && typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }
        var lastCallback = removeCallback(this, "event:".concat(eventName), callback);

        // If there are no callbacks left, remove the listener
        if (lastCallback) {
          this.callMethod('removeEventListener', eventName).catch(function (e) {
            // Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
      }

      /**
       * A promise to load a new video.
       *
       * @promise LoadVideoPromise
       * @fulfill {number} The video with this id or url successfully loaded.
       * @reject {TypeError} The id was not a number.
       */
      /**
       * Load a new video into this embed. The promise will be resolved if
       * the video is successfully loaded, or it will be rejected if it could
       * not be loaded.
       *
       * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
       * @return {LoadVideoPromise}
       */
    }, {
      key: "loadVideo",
      value: function loadVideo(options) {
        return this.callMethod('loadVideo', options);
      }

      /**
       * A promise to perform an action when the Player is ready.
       *
       * @todo document errors
       * @promise LoadVideoPromise
       * @fulfill {void}
       */
      /**
       * Trigger a function when the player iframe has initialized. You do not
       * need to wait for `ready` to trigger to begin adding event listeners
       * or calling other methods.
       *
       * @return {ReadyPromise}
       */
    }, {
      key: "ready",
      value: function ready() {
        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
          reject(new Error('Unknown player. Probably unloaded.'));
        });
        return npo_src.resolve(readyPromise);
      }

      /**
       * A promise to add a cue point to the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point to use for removeCuePoint.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Add a cue point to the player.
       *
       * @param {number} time The time for the cue point.
       * @param {object} [data] Arbitrary data to be returned with the cue point.
       * @return {AddCuePointPromise}
       */
    }, {
      key: "addCuePoint",
      value: function addCuePoint(time) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
          time: time,
          data: data
        });
      }

      /**
       * A promise to remove a cue point from the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point that was removed.
       * @reject {InvalidCuePoint} The cue point with the specified id was not
       *         found.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Remove a cue point from the video.
       *
       * @param {string} id The id of the cue point to remove.
       * @return {RemoveCuePointPromise}
       */
    }, {
      key: "removeCuePoint",
      value: function removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
      }

      /**
       * A representation of a text track on a video.
       *
       * @typedef {Object} VimeoTextTrack
       * @property {string} language The ISO language code.
       * @property {string} kind The kind of track it is (captions or subtitles).
       * @property {string} label The human‐readable label for the track.
       */
      /**
       * A promise to enable a text track.
       *
       * @promise EnableTextTrackPromise
       * @fulfill {VimeoTextTrack} The text track that was enabled.
       * @reject {InvalidTrackLanguageError} No track was available with the
       *         specified language.
       * @reject {InvalidTrackError} No track was available with the specified
       *         language and kind.
       */
      /**
       * Enable the text track with the specified language, and optionally the
       * specified kind (captions or subtitles).
       *
       * When set via the API, the track language will not change the viewer’s
       * stored preference.
       *
       * @param {string} language The two‐letter language code.
       * @param {string} [kind] The kind of track to enable (captions or subtitles).
       * @return {EnableTextTrackPromise}
       */
    }, {
      key: "enableTextTrack",
      value: function enableTextTrack(language, kind) {
        if (!language) {
          throw new TypeError('You must pass a language.');
        }
        return this.callMethod('enableTextTrack', {
          language: language,
          kind: kind
        });
      }

      /**
       * A promise to disable the active text track.
       *
       * @promise DisableTextTrackPromise
       * @fulfill {void} The track was disabled.
       */
      /**
       * Disable the currently-active text track.
       *
       * @return {DisableTextTrackPromise}
       */
    }, {
      key: "disableTextTrack",
      value: function disableTextTrack() {
        return this.callMethod('disableTextTrack');
      }

      /**
       * A promise to pause the video.
       *
       * @promise PausePromise
       * @fulfill {void} The video was paused.
       */
      /**
       * Pause the video if it’s playing.
       *
       * @return {PausePromise}
       */
    }, {
      key: "pause",
      value: function pause() {
        return this.callMethod('pause');
      }

      /**
       * A promise to play the video.
       *
       * @promise PlayPromise
       * @fulfill {void} The video was played.
       */
      /**
       * Play the video if it’s paused. **Note:** on iOS and some other
       * mobile devices, you cannot programmatically trigger play. Once the
       * viewer has tapped on the play button in the player, however, you
       * will be able to use this function.
       *
       * @return {PlayPromise}
       */
    }, {
      key: "play",
      value: function play() {
        return this.callMethod('play');
      }

      /**
       * Request that the player enters fullscreen.
       * @return {Promise}
       */
    }, {
      key: "requestFullscreen",
      value: function requestFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.request(this.element);
        }
        return this.callMethod('requestFullscreen');
      }

      /**
       * Request that the player exits fullscreen.
       * @return {Promise}
       */
    }, {
      key: "exitFullscreen",
      value: function exitFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.exit();
        }
        return this.callMethod('exitFullscreen');
      }

      /**
       * Returns true if the player is currently fullscreen.
       * @return {Promise}
       */
    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        if (screenfull.isEnabled) {
          return npo_src.resolve(screenfull.isFullscreen);
        }
        return this.get('fullscreen');
      }

      /**
       * Request that the player enters picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "requestPictureInPicture",
      value: function requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
      }

      /**
       * Request that the player exits picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "exitPictureInPicture",
      value: function exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
      }

      /**
       * Returns true if the player is currently picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "getPictureInPicture",
      value: function getPictureInPicture() {
        return this.get('pictureInPicture');
      }

      /**
       * A promise to prompt the viewer to initiate remote playback.
       *
       * @promise RemotePlaybackPromptPromise
       * @fulfill {void}
       * @reject {NotFoundError} No remote playback device is available.
       */
      /**
       * Request to prompt the user to initiate remote playback.
       *
       * @return {RemotePlaybackPromptPromise}
       */
    }, {
      key: "remotePlaybackPrompt",
      value: function remotePlaybackPrompt() {
        return this.callMethod('remotePlaybackPrompt');
      }

      /**
       * A promise to unload the video.
       *
       * @promise UnloadPromise
       * @fulfill {void} The video was unloaded.
       */
      /**
       * Return the player to its initial state.
       *
       * @return {UnloadPromise}
       */
    }, {
      key: "unload",
      value: function unload() {
        return this.callMethod('unload');
      }

      /**
       * Cleanup the player and remove it from the DOM
       *
       * It won't be usable and a new one should be constructed
       *  in order to do any operations.
       *
       * @return {Promise}
       */
    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;
        return new npo_src(function (resolve) {
          readyMap.delete(_this5);
          playerMap.delete(_this5.element);
          if (_this5._originalElement) {
            playerMap.delete(_this5._originalElement);
            _this5._originalElement.removeAttribute('data-vimeo-initialized');
          }
          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
              _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
            } else {
              _this5.element.parentNode.removeChild(_this5.element);
            }
          }

          // If the clip is private there is a case where the element stays the
          // div element. Destroy should reset the div and remove the iframe child.
          if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
            _this5.element.removeAttribute('data-vimeo-initialized');
            var iframe = _this5.element.querySelector('iframe');
            if (iframe && iframe.parentNode) {
              // If we've added an additional wrapper div, remove that from the DOM.
              // If not, just remove the iframe element.
              if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
                iframe.parentNode.parentNode.removeChild(iframe.parentNode);
              } else {
                iframe.parentNode.removeChild(iframe);
              }
            }
          }
          _this5._window.removeEventListener('message', _this5._onMessage);
          if (screenfull.isEnabled) {
            screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
          }
          resolve();
        });
      }

      /**
       * A promise to get the autopause behavior of the video.
       *
       * @promise GetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */
      /**
       * Get the autopause behavior for this player.
       *
       * @return {GetAutopausePromise}
       */
    }, {
      key: "getAutopause",
      value: function getAutopause() {
        return this.get('autopause');
      }

      /**
       * A promise to set the autopause behavior of the video.
       *
       * @promise SetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */
      /**
       * Enable or disable the autopause behavior of this player.
       *
       * By default, when another video is played in the same browser, this
       * player will automatically pause. Unless you have a specific reason
       * for doing so, we recommend that you leave autopause set to the
       * default (`true`).
       *
       * @param {boolean} autopause
       * @return {SetAutopausePromise}
       */
    }, {
      key: "setAutopause",
      value: function setAutopause(autopause) {
        return this.set('autopause', autopause);
      }

      /**
       * A promise to get the buffered property of the video.
       *
       * @promise GetBufferedPromise
       * @fulfill {Array} Buffered Timeranges converted to an Array.
       */
      /**
       * Get the buffered property of the video.
       *
       * @return {GetBufferedPromise}
       */
    }, {
      key: "getBuffered",
      value: function getBuffered() {
        return this.get('buffered');
      }

      /**
       * @typedef {Object} CameraProperties
       * @prop {number} props.yaw - Number between 0 and 360.
       * @prop {number} props.pitch - Number between -90 and 90.
       * @prop {number} props.roll - Number between -180 and 180.
       * @prop {number} props.fov - The field of view in degrees.
       */
      /**
       * A promise to get the camera properties of the player.
       *
       * @promise GetCameraPromise
       * @fulfill {CameraProperties} The camera properties.
       */
      /**
       * For 360° videos get the camera properties for this player.
       *
       * @return {GetCameraPromise}
       */
    }, {
      key: "getCameraProps",
      value: function getCameraProps() {
        return this.get('cameraProps');
      }

      /**
       * A promise to set the camera properties of the player.
       *
       * @promise SetCameraPromise
       * @fulfill {Object} The camera was successfully set.
       * @reject {RangeError} The range was out of bounds.
       */
      /**
       * For 360° videos set the camera properties for this player.
       *
       * @param {CameraProperties} camera The camera properties
       * @return {SetCameraPromise}
       */
    }, {
      key: "setCameraProps",
      value: function setCameraProps(camera) {
        return this.set('cameraProps', camera);
      }

      /**
       * A representation of a chapter.
       *
       * @typedef {Object} VimeoChapter
       * @property {number} startTime The start time of the chapter.
       * @property {object} title The title of the chapter.
       * @property {number} index The place in the order of Chapters. Starts at 1.
       */
      /**
       * A promise to get chapters for the video.
       *
       * @promise GetChaptersPromise
       * @fulfill {VimeoChapter[]} The chapters for the video.
       */
      /**
       * Get an array of all the chapters for the video.
       *
       * @return {GetChaptersPromise}
       */
    }, {
      key: "getChapters",
      value: function getChapters() {
        return this.get('chapters');
      }

      /**
       * A promise to get the currently active chapter.
       *
       * @promise GetCurrentChaptersPromise
       * @fulfill {VimeoChapter|undefined} The current chapter for the video.
       */
      /**
       * Get the currently active chapter for the video.
       *
       * @return {GetCurrentChaptersPromise}
       */
    }, {
      key: "getCurrentChapter",
      value: function getCurrentChapter() {
        return this.get('currentChapter');
      }

      /**
       * A promise to get the accent color of the player.
       *
       * @promise GetColorPromise
       * @fulfill {string} The hex color of the player.
       */
      /**
       * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
       *
       * @return {GetColorPromise}
       */
    }, {
      key: "getColor",
      value: function getColor() {
        return this.get('color');
      }

      /**
       * A promise to get all colors for the player in an array.
       *
       * @promise GetColorsPromise
       * @fulfill {string[]} The hex colors of the player.
       */
      /**
       * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
       *
       * @return {GetColorPromise}
       */
    }, {
      key: "getColors",
      value: function getColors() {
        return npo_src.all([this.get('colorOne'), this.get('colorTwo'), this.get('colorThree'), this.get('colorFour')]);
      }

      /**
       * A promise to set the accent color of the player.
       *
       * @promise SetColorPromise
       * @fulfill {string} The color was successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */
      /**
       * Set the accent color of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       * Note this is deprecated in place of `setColorTwo`.
       *
       * @param {string} color The hex or rgb color string to set.
       * @return {SetColorPromise}
       */
    }, {
      key: "setColor",
      value: function setColor(color) {
        return this.set('color', color);
      }

      /**
       * A promise to set all colors for the player.
       *
       * @promise SetColorsPromise
       * @fulfill {string[]} The colors were successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */
      /**
       * Set the colors of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
       * If a color should not be set, the index in the array can be left as null.
       *
       * @param {string[]} colors Array of the hex or rgb color strings to set.
       * @return {SetColorsPromise}
       */
    }, {
      key: "setColors",
      value: function setColors(colors) {
        if (!Array.isArray(colors)) {
          return new npo_src(function (resolve, reject) {
            return reject(new TypeError('Argument must be an array.'));
          });
        }
        var nullPromise = new npo_src(function (resolve) {
          return resolve(null);
        });
        var colorPromises = [colors[0] ? this.set('colorOne', colors[0]) : nullPromise, colors[1] ? this.set('colorTwo', colors[1]) : nullPromise, colors[2] ? this.set('colorThree', colors[2]) : nullPromise, colors[3] ? this.set('colorFour', colors[3]) : nullPromise];
        return npo_src.all(colorPromises);
      }

      /**
       * A representation of a cue point.
       *
       * @typedef {Object} VimeoCuePoint
       * @property {number} time The time of the cue point.
       * @property {object} data The data passed when adding the cue point.
       * @property {string} id The unique id for use with removeCuePoint.
       */
      /**
       * A promise to get the cue points of a video.
       *
       * @promise GetCuePointsPromise
       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Get an array of the cue points added to the video.
       *
       * @return {GetCuePointsPromise}
       */
    }, {
      key: "getCuePoints",
      value: function getCuePoints() {
        return this.get('cuePoints');
      }

      /**
       * A promise to get the current time of the video.
       *
       * @promise GetCurrentTimePromise
       * @fulfill {number} The current time in seconds.
       */
      /**
       * Get the current playback position in seconds.
       *
       * @return {GetCurrentTimePromise}
       */
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.get('currentTime');
      }

      /**
       * A promise to set the current time of the video.
       *
       * @promise SetCurrentTimePromise
       * @fulfill {number} The actual current time that was set.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       */
      /**
       * Set the current playback position in seconds. If the player was
       * paused, it will remain paused. Likewise, if the player was playing,
       * it will resume playing once the video has buffered.
       *
       * You can provide an accurate time and the player will attempt to seek
       * to as close to that time as possible. The exact time will be the
       * fulfilled value of the promise.
       *
       * @param {number} currentTime
       * @return {SetCurrentTimePromise}
       */
    }, {
      key: "setCurrentTime",
      value: function setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
      }

      /**
       * A promise to get the duration of the video.
       *
       * @promise GetDurationPromise
       * @fulfill {number} The duration in seconds.
       */
      /**
       * Get the duration of the video in seconds. It will be rounded to the
       * nearest second before playback begins, and to the nearest thousandth
       * of a second after playback begins.
       *
       * @return {GetDurationPromise}
       */
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.get('duration');
      }

      /**
       * A promise to get the ended state of the video.
       *
       * @promise GetEndedPromise
       * @fulfill {boolean} Whether or not the video has ended.
       */
      /**
       * Get the ended state of the video. The video has ended if
       * `currentTime === duration`.
       *
       * @return {GetEndedPromise}
       */
    }, {
      key: "getEnded",
      value: function getEnded() {
        return this.get('ended');
      }

      /**
       * A promise to get the loop state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the player is set to loop.
       */
      /**
       * Get the loop state of the player.
       *
       * @return {GetLoopPromise}
       */
    }, {
      key: "getLoop",
      value: function getLoop() {
        return this.get('loop');
      }

      /**
       * A promise to set the loop state of the player.
       *
       * @promise SetLoopPromise
       * @fulfill {boolean} The loop state that was set.
       */
      /**
       * Set the loop state of the player. When set to `true`, the player
       * will start over immediately once playback ends.
       *
       * @param {boolean} loop
       * @return {SetLoopPromise}
       */
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        return this.set('loop', loop);
      }

      /**
       * A promise to set the muted state of the player.
       *
       * @promise SetMutedPromise
       * @fulfill {boolean} The muted state that was set.
       */
      /**
       * Set the muted state of the player. When set to `true`, the player
       * volume will be muted.
       *
       * @param {boolean} muted
       * @return {SetMutedPromise}
       */
    }, {
      key: "setMuted",
      value: function setMuted(muted) {
        return this.set('muted', muted);
      }

      /**
       * A promise to get the muted state of the player.
       *
       * @promise GetMutedPromise
       * @fulfill {boolean} Whether or not the player is muted.
       */
      /**
       * Get the muted state of the player.
       *
       * @return {GetMutedPromise}
       */
    }, {
      key: "getMuted",
      value: function getMuted() {
        return this.get('muted');
      }

      /**
       * A promise to get the paused state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the video is paused.
       */
      /**
       * Get the paused state of the player.
       *
       * @return {GetLoopPromise}
       */
    }, {
      key: "getPaused",
      value: function getPaused() {
        return this.get('paused');
      }

      /**
       * A promise to get the playback rate of the player.
       *
       * @promise GetPlaybackRatePromise
       * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
       */
      /**
       * Get the playback rate of the player on a scale from `0` to `2`.
       *
       * @return {GetPlaybackRatePromise}
       */
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.get('playbackRate');
      }

      /**
       * A promise to set the playbackrate of the player.
       *
       * @promise SetPlaybackRatePromise
       * @fulfill {number} The playback rate was set.
       * @reject {RangeError} The playback rate was less than 0 or greater than 2.
       */
      /**
       * Set the playback rate of the player on a scale from `0` to `2`. When set
       * via the API, the playback rate will not be synchronized to other
       * players or stored as the viewer's preference.
       *
       * @param {number} playbackRate
       * @return {SetPlaybackRatePromise}
       */
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
      }

      /**
       * A promise to get the played property of the video.
       *
       * @promise GetPlayedPromise
       * @fulfill {Array} Played Timeranges converted to an Array.
       */
      /**
       * Get the played property of the video.
       *
       * @return {GetPlayedPromise}
       */
    }, {
      key: "getPlayed",
      value: function getPlayed() {
        return this.get('played');
      }

      /**
       * A promise to get the qualities available of the current video.
       *
       * @promise GetQualitiesPromise
       * @fulfill {Array} The qualities of the video.
       */
      /**
       * Get the qualities of the current video.
       *
       * @return {GetQualitiesPromise}
       */
    }, {
      key: "getQualities",
      value: function getQualities() {
        return this.get('qualities');
      }

      /**
       * A promise to get the current set quality of the video.
       *
       * @promise GetQualityPromise
       * @fulfill {string} The current set quality.
       */
      /**
       * Get the current set quality of the video.
       *
       * @return {GetQualityPromise}
       */
    }, {
      key: "getQuality",
      value: function getQuality() {
        return this.get('quality');
      }

      /**
       * A promise to set the video quality.
       *
       * @promise SetQualityPromise
       * @fulfill {number} The quality was set.
       * @reject {RangeError} The quality is not available.
       */
      /**
       * Set a video quality.
       *
       * @param {string} quality
       * @return {SetQualityPromise}
       */
    }, {
      key: "setQuality",
      value: function setQuality(quality) {
        return this.set('quality', quality);
      }

      /**
       * A promise to get the remote playback availability.
       *
       * @promise RemotePlaybackAvailabilityPromise
       * @fulfill {boolean} Whether remote playback is available.
       */
      /**
       * Get the availability of remote playback.
       *
       * @return {RemotePlaybackAvailabilityPromise}
       */
    }, {
      key: "getRemotePlaybackAvailability",
      value: function getRemotePlaybackAvailability() {
        return this.get('remotePlaybackAvailability');
      }

      /**
       * A promise to get the current remote playback state.
       *
       * @promise RemotePlaybackStatePromise
       * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
       */
      /**
       * Get the current remote playback state.
       *
       * @return {RemotePlaybackStatePromise}
       */
    }, {
      key: "getRemotePlaybackState",
      value: function getRemotePlaybackState() {
        return this.get('remotePlaybackState');
      }

      /**
       * A promise to get the seekable property of the video.
       *
       * @promise GetSeekablePromise
       * @fulfill {Array} Seekable Timeranges converted to an Array.
       */
      /**
       * Get the seekable property of the video.
       *
       * @return {GetSeekablePromise}
       */
    }, {
      key: "getSeekable",
      value: function getSeekable() {
        return this.get('seekable');
      }

      /**
       * A promise to get the seeking property of the player.
       *
       * @promise GetSeekingPromise
       * @fulfill {boolean} Whether or not the player is currently seeking.
       */
      /**
       * Get if the player is currently seeking.
       *
       * @return {GetSeekingPromise}
       */
    }, {
      key: "getSeeking",
      value: function getSeeking() {
        return this.get('seeking');
      }

      /**
       * A promise to get the text tracks of a video.
       *
       * @promise GetTextTracksPromise
       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
       */
      /**
       * Get an array of the text tracks that exist for the video.
       *
       * @return {GetTextTracksPromise}
       */
    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return this.get('textTracks');
      }

      /**
       * A promise to get the embed code for the video.
       *
       * @promise GetVideoEmbedCodePromise
       * @fulfill {string} The `<iframe>` embed code for the video.
       */
      /**
       * Get the `<iframe>` embed code for the video.
       *
       * @return {GetVideoEmbedCodePromise}
       */
    }, {
      key: "getVideoEmbedCode",
      value: function getVideoEmbedCode() {
        return this.get('videoEmbedCode');
      }

      /**
       * A promise to get the id of the video.
       *
       * @promise GetVideoIdPromise
       * @fulfill {number} The id of the video.
       */
      /**
       * Get the id of the video.
       *
       * @return {GetVideoIdPromise}
       */
    }, {
      key: "getVideoId",
      value: function getVideoId() {
        return this.get('videoId');
      }

      /**
       * A promise to get the title of the video.
       *
       * @promise GetVideoTitlePromise
       * @fulfill {number} The title of the video.
       */
      /**
       * Get the title of the video.
       *
       * @return {GetVideoTitlePromise}
       */
    }, {
      key: "getVideoTitle",
      value: function getVideoTitle() {
        return this.get('videoTitle');
      }

      /**
       * A promise to get the native width of the video.
       *
       * @promise GetVideoWidthPromise
       * @fulfill {number} The native width of the video.
       */
      /**
       * Get the native width of the currently‐playing video. The width of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoWidthPromise}
       */
    }, {
      key: "getVideoWidth",
      value: function getVideoWidth() {
        return this.get('videoWidth');
      }

      /**
       * A promise to get the native height of the video.
       *
       * @promise GetVideoHeightPromise
       * @fulfill {number} The native height of the video.
       */
      /**
       * Get the native height of the currently‐playing video. The height of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoHeightPromise}
       */
    }, {
      key: "getVideoHeight",
      value: function getVideoHeight() {
        return this.get('videoHeight');
      }

      /**
       * A promise to get the vimeo.com url for the video.
       *
       * @promise GetVideoUrlPromise
       * @fulfill {number} The vimeo.com url for the video.
       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
       */
      /**
       * Get the vimeo.com url for the video.
       *
       * @return {GetVideoUrlPromise}
       */
    }, {
      key: "getVideoUrl",
      value: function getVideoUrl() {
        return this.get('videoUrl');
      }

      /**
       * A promise to get the volume level of the player.
       *
       * @promise GetVolumePromise
       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
       */
      /**
       * Get the current volume level of the player on a scale from `0` to `1`.
       *
       * Most mobile devices do not support an independent volume from the
       * system volume. In those cases, this method will always return `1`.
       *
       * @return {GetVolumePromise}
       */
    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.get('volume');
      }

      /**
       * A promise to set the volume level of the player.
       *
       * @promise SetVolumePromise
       * @fulfill {number} The volume was set.
       * @reject {RangeError} The volume was less than 0 or greater than 1.
       */
      /**
       * Set the volume of the player on a scale from `0` to `1`. When set
       * via the API, the volume level will not be synchronized to other
       * players or stored as the viewer’s preference.
       *
       * Most mobile devices do not support setting the volume. An error will
       * *not* be triggered in that situation.
       *
       * @param {number} volume
       * @return {SetVolumePromise}
       */
    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        return this.set('volume', volume);
      }

      /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
      /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
      /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */

      /**
       * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
       *
       * @param {TimingObject} timingObject
       * @param {TimingSrcConnectorOptions} options
       *
       * @return {Promise<TimingSrcConnector>}
       */
    }, {
      key: "setTimingSrc",
      value: function () {
        var _setTimingSrc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(timingObject, options) {
          var _this6 = this;
          var connector;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (timingObject) {
                  _context.next = 2;
                  break;
                }
                throw new TypeError('A Timing Object must be provided.');
              case 2:
                _context.next = 4;
                return this.ready();
              case 4:
                connector = new TimingSrcConnector(this, timingObject, options);
                postMessage(this, 'notifyTimingObjectConnect');
                connector.addEventListener('disconnect', function () {
                  return postMessage(_this6, 'notifyTimingObjectDisconnect');
                });
                return _context.abrupt("return", connector);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function setTimingSrc(_x, _x2) {
          return _setTimingSrc.apply(this, arguments);
        }
        return setTimingSrc;
      }()
    }]);
    return Player;
  }(); // Setup embed only if this is not a node environment
  if (!isNode) {
    screenfull = initializeScreenfull();
    initializeEmbeds();
    resizeEmbeds();
    initAppendVideoMetadata();
    checkUrlTimeParam();
  }

  return Player;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":3}],2:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":2,"timers":3}],4:[function(require,module,exports){
"use strict";

var _gtm = require("./gtm.js");
// This file is for generic, standard accordions
// NOT content library accordions
document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll('.accordion-item');
  var accordionTriggers = document.querySelectorAll('.accordion-trigger');
  if (accordionItems.length === 0) return;
  accordionItems.forEach(function (item) {
    var trigger = item.querySelector('.accordion-trigger');
    trigger.addEventListener('click', function () {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      var content = this.nextElementSibling;
      content.style.display = isExpanded ? 'none' : 'block';
      // Toggle active class on parent
      isExpanded ? this.classList.remove('active') : this.classList.add('active');

      // special case to toggle text content of audio transcript accordion
      if (this.dataset.type === 'transcript') {
        this.textContent = isExpanded ? 'View Transcript' : 'Close Transcript';
        var gtmAction = isExpanded ? 'Collapse - Close Transcript' : 'Expand - View Transcript';
        var transcriptionType = this.getAttribute('data-transcription-type') || 'Podcast';
        if (transcriptionType === 'video') (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', "".concat(this.getAttribute('data-gtm-page-title'), " - ").concat(gtmAction), 'gtm-action');else (0, _gtm.sendGTMEvent)(transcriptionType, transcriptionType, gtmAction, this.getAttribute('data-gtm-page-title'), 'gtm-podcast');
      } else {
        var _gtmAction = isExpanded ? 'Collapse' : 'Expand';
        (0, _gtm.sendGTMEvent)('Accordion', 'Accordion', _gtmAction, this.getAttribute('data-gtm-title'), 'gtm-accordion');
      }
      checkFaqsState();
    });
  });

  // Expand All
  var expandAll = function expandAll(e) {
    collapse.classList.remove('disabled');
    e.target.classList.add('disabled');
    accordionTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.nextElementSibling.style.display = 'block';
      trigger.classList.add('active');
    });
  };

  // Collapse All
  var collapseAll = function collapseAll(e) {
    e.target.classList.add('disabled');
    expand.classList.remove('disabled');
    accordionTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.nextElementSibling.style.display = 'none';
      trigger.classList.remove('active');
    });
  };
  var expand = document.getElementById('expand-all');
  var collapse = document.getElementById('collapse-all');
  if (expand) expand.addEventListener('click', expandAll);
  if (collapse) collapse.addEventListener('click', collapseAll);

  // Some FAQ-specific logic
  var checkFaqsState = function checkFaqsState() {
    var faqs = document.querySelectorAll('.faculty-faqs-block');
    if (!faqs.length || !expand || !collapse) return;
    faqs.forEach(function (faq) {
      var totalItems = faq.querySelectorAll('.accordion-trigger').length;
      var openItems = faq.querySelectorAll('.accordion-trigger.active').length;
      if (openItems === 0) {
        expand.classList.remove('disabled');
        collapse.classList.add('disabled');
      } else if (openItems === totalItems) {
        expand.classList.add('disabled');
        collapse.classList.remove('disabled');
      } else {
        expand.classList.remove('disabled');
        collapse.classList.remove('disabled');
      }
    });
  };
});

},{"./gtm.js":14}],5:[function(require,module,exports){
"use strict";

var _gtm = require("./gtm.js");
document.addEventListener('DOMContentLoaded', function () {
  var _document$querySelect;
  var quizSelections = document.querySelectorAll('.quiz-answer');
  var answerButton = document.querySelectorAll('.answer-button-block');
  var relatedPages = document.querySelector('.related-pages');
  var selected;
  getSelection();

  //Assessment next button
  var nextButton = document.querySelector(".assessment-next");

  //Quiz selected style
  quizSelections.forEach(function (select) {
    select.addEventListener('click', function () {
      var selectReset = document.querySelectorAll('.quiz-answer');
      var checkedValue = select.querySelector('input').checked;
      var gtmLabel = select.getAttribute('data-gtm-title');
      (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', gtmLabel, 'gtm-quiz');
      selectReset.forEach(function (sel) {
        sel.classList.remove('selected');
      });
      if (checkedValue === true) {
        select.classList.add('selected');
      } else {
        select.classList.add('selected');
        select.querySelector('input').checked = true;
      }
      selected = document.querySelector('.selected');
      if (selected) {
        saveSelection();

        //Quiz Next Button
        answerButton.forEach(function (btn) {
          btn.classList.remove('disabled');
        });
      }
      applySelectStyling();
      updateNextButtonStatus();
    });
  });
  var prevAnswerButton = document.querySelector('.previous-answer-button');
  if (prevAnswerButton) {
    prevAnswerButton.addEventListener('click', function () {
      sessionStorage.setItem('quiz_view_answer', 'true');
    });
  }
  var showAnswer = sessionStorage.getItem('quiz_view_answer');
  if (showAnswer) {
    var question = document.querySelector('.quiz-video-wrapper');
    if (question) question.style.display = 'none';
    var answer = document.querySelector('.answer-wrapper');
    if (answer) answer.style.display = 'block';
    sessionStorage.removeItem('quiz_view_answer');
    var questionId = document.querySelector('.quiz-question').getAttribute('id');
    var currentNumber = parseInt(questionId.split('-').pop());
    var previousQuestionId = "quiz-question-".concat(currentNumber, "-outcome");
    var previousOutcome = sessionStorage.getItem(previousQuestionId);
    if (previousOutcome === "True") {
      document.querySelector('.correct-answer').style.display = 'block';
      document.querySelector('.incorrect-answer').style.display = 'none';
    }
    if (previousOutcome === "False") {
      document.querySelector('.correct-answer').style.display = 'none';
      document.querySelector('.incorrect-answer').style.display = 'block';
    }
  }

  //Show answer on next
  answerButton.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (!button.classList.contains('disabled')) {
        selected = document.querySelector('.selected');
        var selectedInput = selected.querySelector('input');
        var attributeValue = selectedInput.getAttribute('data-ans');
        if (attributeValue === "True") {
          var incorrect = document.querySelector('.incorrect-answer');
          incorrect.style.display = 'none';
        }
        if (attributeValue === "False") {
          var correct = document.querySelector('.correct-answer');
          correct.style.display = 'none';
        }
        saveSelection();
        var answerWrapper = document.querySelector('.answer-wrapper');
        var quizVideo = document.querySelector('.quiz-video-wrapper');
        answerWrapper.style.display = "block";
        quizVideo.style.display = "none";
      }
      sendFlying(120);
    });
  });

  //Assessment Page - Get Started Button
  var assessmentWrapper = document.querySelector('.assessment-wrapper');
  var firstAssessmentRating = document.querySelector('.assessment-rating1');
  if (assessmentWrapper) {
    var getStartedButton = document.querySelector('.get-started-button');
    if (getStartedButton) {
      getStartedButton.addEventListener('click', function (e) {
        e.preventDefault();
        var assessmentSection = document.querySelector('.assessment-section');
        var assessmentIntroduction = document.querySelector('.assessment-introduction');
        assessmentSection.classList.add('show');
        firstAssessmentRating.classList.add('show');
        assessmentIntroduction.style.display = 'none';
        scrollToElement('assessment-wrapper');
        (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', 'Start the Quiz', 'gtm-quiz');
      });
    }
  }
  ;

  //Assessment Block
  var assessmentBlock = document.querySelector('.assessment-block');
  if (assessmentBlock) {
    firstAssessmentRating.classList.add('show');
  }

  //Assessment Page Navigation
  var totalAssessmentQuestions = document.querySelectorAll('[data-question]');
  var prevButton = document.querySelector(".assessment-prev");
  var questionText = (_document$querySelect = document.querySelector('.assessment-question-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerText;
  var currentQuestion;
  var questionNumber;
  var totalRatings;
  if (prevButton) {
    prevButton.addEventListener('click', function (e) {
      e.preventDefault();
      currentQuestion = document.querySelector(".assessment-rating.show");
      questionNumber = currentQuestion.getAttribute("data-question");
      var prevNumber = Number(questionNumber) - 1;
      var prevQuestion = document.querySelector("[data-question=\"".concat(prevNumber, "\"]"));
      var gtmLabel = "".concat(questionText, " (").concat(questionNumber, " of ").concat(totalAssessmentQuestions.length, ") - Previous");
      (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', gtmLabel, 'gtm-internal-link');
      if (Number(questionNumber) === 1) {
        currentQuestion.classList.remove('show');
        var assessmentSection = document.querySelector('.assessment-section');
        var assessmentIntroduction = document.querySelector('.assessment-introduction');
        assessmentIntroduction.style.display = "block";
        assessmentReferences.style.display = "block";
        assessmentSection.classList.remove('show');
      } else {
        currentQuestion.classList.remove('show');
        prevQuestion.classList.add('show');
      }
      updatePageNumber(-1);
      saveRating(questionNumber);
      calculateTotalRatings();
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (nextButton && !nextButton.classList.contains('disabled')) {
        currentQuestion = document.querySelector(".assessment-rating.show");
        questionNumber = currentQuestion.getAttribute("data-question");
        var nextNumber = Number(questionNumber) + 1;
        var nextQuestion = document.querySelector("[data-question=\"".concat(nextNumber, "\"]"));
        var assessmentRating = document.querySelectorAll('.assessment-rating');
        if (Number(questionNumber) === Number(totalAssessmentQuestions.length)) {
          var assessmentCommentaries = document.querySelector('.assessment-commentaries');
          var assessmentQuestions = document.querySelector('.assessment-questions-wrapper');
          var pageCounter = document.querySelector('.assessment-section .page-count');
          var assessmentHeader = document.querySelector('.assessment-section .assessment-question-header');
          assessmentQuestions.style.display = 'none';
          pageCounter.style.display = 'none';
          assessmentHeader.style.display = 'none';
          assessmentCommentaries.style.display = 'block';
          if (relatedPages) relatedPages.style.display = 'block';
          scrollToElement("commentaries-h2");
        } else {
          if (assessmentBlock) {
            currentQuestion.classList.remove('show');
          }
          currentQuestion.classList.remove('show');
          nextQuestion.classList.add('show');
        }
        var gtmLabel = "".concat(questionText, " (").concat(questionNumber, " of ").concat(totalAssessmentQuestions.length, ") - Next");
        (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', gtmLabel, 'gtm-internal-link');
        scrollToElement("assessment-wrapper");
        updatePageNumber(1);
        saveRating(questionNumber);
        getSelection();
        calculateTotalRatings();
        resetButton();
        applySelectStyling();
      }
    });
  }

  // Assessment Input events
  var assessmentInputs = document.querySelectorAll('.quiz-answer');
  if (assessmentInputs && assessmentInputs.length > 0) {
    assessmentInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        currentQuestion = document.querySelector(".assessment-rating.show");
        if (!currentQuestion) return;
        questionNumber = currentQuestion.getAttribute('data-question');
        var gtmLabel = "".concat(questionText, " (").concat(questionNumber, " of ").concat(totalAssessmentQuestions.length, ") - ").concat(input.querySelector('label').innerText);
        (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', gtmLabel, 'gtm-quiz');
      });
    });
  }

  //Assessment Commentary Tabs
  var tabButtons = document.querySelectorAll('.tab-button');
  var tabContentItems = document.querySelectorAll('.tab-content-item');
  if (tabButtons && tabContentItems) {
    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetTab = button.getAttribute('data-tab');
        tabButtons.forEach(function (btn) {
          btn.classList.remove('active');
        });
        button.classList.add('active');
        tabContentItems.forEach(function (content) {
          if (content.id === targetTab) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      });
    });
  }

  //Quiz Scrolling
  var quizWrapper = document.querySelector('.quiz-wrapper');
  if (quizWrapper) {
    // Correct selector for the Start the quiz button
    var _getStartedButton = document.querySelector('.get-started-button a.button-block');
    var _nextButton = document.querySelector('.quiz-navigation .button-block');
    if (sessionStorage.getItem('scroll_to_one')) {
      setTimeout(function () {
        scrollToElement('quiz-wrapper');
        sessionStorage.removeItem('scroll_to_one');
      }, 50);
    }
    if (_getStartedButton) {
      _getStartedButton.addEventListener('click', function () {
        (0, _gtm.sendGTMEvent)('Quiz', 'Quiz', 'Click', 'Start the Quiz', 'gtm-quiz');
        sessionStorage.setItem('scroll_to_one', 'true');
      });
    }
    if (_nextButton) {
      _nextButton.addEventListener('click', function () {
        scrollToElement('quiz-wrapper');
      });
    }
  }
  function saveRating(questionNumber) {
    var group = document.querySelector(".assessment-rating".concat(questionNumber));
    var assessmentAnswer = group.querySelector('.assessment-rating-answer.selected');
    var ratingSelectedValue = assessmentAnswer.querySelector('input').value;
    sessionStorage.setItem('rating' + questionNumber, ratingSelectedValue);
  }
  ;
  function saveSelection() {
    var quizWrapper = document.querySelector('.quiz-wrapper');
    var question = document.querySelector('.quiz-question');
    if (!quizWrapper || !question) return;
    var questionId = question.getAttribute('id');
    var answerSelected = document.querySelector('.quiz-question .selected input').getAttribute('id');
    var answerOutcome = document.getElementById(answerSelected).getAttribute('data-ans');
    sessionStorage.setItem(questionId, answerSelected);
    sessionStorage.setItem("".concat(questionId, "-outcome"), answerOutcome);
  }
  function getSelection() {
    var quizWrapper = document.querySelector('.quiz-wrapper');
    var answerButton = document.querySelector('.answer-button-block');
    var question = document.querySelector('.quiz-question');
    if (!quizWrapper || !question) return;
    var questionId = question.getAttribute('id');
    var savedSelections = sessionStorage.getItem(questionId);
    if (!savedSelections) return;
    document.getElementById(savedSelections).checked = true;
    if (answerButton.classList.contains('disabled')) {
      answerButton.classList.remove('disabled');
    }
    applySelectStyling();
  }
  ;
  function calculateTotalRatings() {
    var totalRatingContainer = document.querySelector('.final-rating');
    totalRatings = 0;
    for (var i = 1; i <= totalAssessmentQuestions.length; i++) {
      var sessionValue = sessionStorage.getItem('rating' + i);
      var sessionValueNumber = Number(sessionValue);
      totalRatings += sessionValueNumber;
    }
    totalRatingContainer.innerHTML = totalRatings;
  }
  function resetButton() {
    var selecteds = document.querySelectorAll('.selected');
    selecteds.forEach(function (sel) {
      sel.classList.remove('selected');
    });
    nextButton.classList.add('disabled');
  }
  function sendFlying() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var quizWrapper = document.querySelector('.quiz-wrapper');
    if (quizWrapper) {
      var topPosition = quizWrapper.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
      });
    }
  }
  function applySelectStyling() {
    var answerSelections = document.querySelectorAll('.quiz-answer');
    answerSelections.forEach(function (ans) {
      if (ans.querySelector('input').checked === true) {
        ans.classList.add('selected');
      }
      if (ans.querySelector('input').checked === false) {
        if (ans.classList.contains('selected')) {
          ans.classList.remove('selected');
        }
      }
    });
  }
  function updatePageNumber(num) {
    var currentPageNum = document.querySelector('#current-page');
    var pageNum = Number(questionNumber) + num;
    prevButton.style.display = pageNum <= 1 ? 'none' : 'block';
    currentPageNum.innerHTML = "".concat(pageNum, " of 7");
    if (assessmentBlock) {
      var count = document.querySelectorAll('.page-count');
      count.forEach(function (el) {
        el.innerHTML = "".concat(pageNum, " of 7");
      });
    }
    updateNextButtonStatus();
  }
  function updateNextButtonStatus() {
    var currentAssessmentShowing = document.querySelector('.assessment-questions-ratings .show');
    if (currentAssessmentShowing && currentAssessmentShowing.querySelector('.selected')) {
      if (nextButton.classList.contains('disabled')) {
        nextButton.classList.remove('disabled');
      }
    } else {
      if (nextButton && !nextButton.classList.contains('disabled')) {
        nextButton.classList.add('disabled');
      }
    }
  }
  function scrollToElement(elementId) {
    var element = document.getElementById(elementId);
    if (!element) return;
    var navElement = document.querySelector('.global-header-main');
    var navHeight = navElement ? navElement.offsetHeight : 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - navHeight;
    console.log(offsetPosition);
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
  applySelectStyling();
  updateNextButtonStatus();
});

},{"./gtm.js":14}],6:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var audioPlayers = document.querySelectorAll('.audio-player');
  if (!audioPlayers) return;
  var formatTime = function formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = Math.floor(seconds % 60);
    return "".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, '0'));
  };
  audioPlayers.forEach(function (audioPlayer) {
    var audioElement = audioPlayer.querySelector('.audio-element');
    var playButton = audioPlayer.querySelector('.play-button');
    var pauseButton = audioPlayer.querySelector('.pause-button');
    var progressBar = audioPlayer.querySelector('.progress-bar');
    var progressFill = audioPlayer.querySelector('.progress-fill');
    var currentTimeDisplay = audioPlayer.querySelector('.current-time');
    var totalTimeDisplay = audioPlayer.querySelector('.total-time');
    var previousButton = audioPlayer.querySelector('.previous-button');
    var nextButton = audioPlayer.querySelector('.next-button');
    var volumeControl = audioPlayer.querySelector('.volume-control');
    var volumeOnSvg = audioPlayer.querySelector('.volume-on');
    var volumeOffSvg = audioPlayer.querySelector('.volume-off');

    // Initialize tracking flags to ensure each event only fires once
    var trackingFlags = {
      quarter: false,
      half: false,
      threeQuarters: false,
      complete: false
    };
    var sendGTMProgressEvent = function sendGTMProgressEvent(eventAction) {
      window.dataLayer.push({
        'event': 'Podcast',
        'eventCategory': 'Podcast',
        'eventAction': eventAction,
        'eventLabel': audioElement.getAttribute('data-gtm-title'),
        'gtm.elementClasses': 'gtm-podcast'
      });
    };

    // Update total duration once metadata is loaded
    if (audioElement.readyState >= 2) {
      // Metadata is already loaded
      totalTimeDisplay.textContent = formatTime(audioElement.duration);
    } else {
      // Wait for metadata to load
      audioElement.addEventListener('loadedmetadata', function () {
        totalTimeDisplay.textContent = formatTime(audioElement.duration);
      });
    }

    // Update current time display and progress bar
    audioElement.addEventListener('timeupdate', function () {
      var currentTime = audioElement.currentTime;
      var duration = audioElement.duration;
      var progress = currentTime / duration * 100;
      currentTimeDisplay.textContent = formatTime(currentTime);
      progressFill.style.width = "".concat(progress, "%");

      // Track 25% played
      if (progress >= 25 && !trackingFlags.quarter) {
        sendGTMProgressEvent('25%');
        trackingFlags.quarter = true;
      }

      // Track 50% played
      if (progress >= 50 && !trackingFlags.half) {
        sendGTMProgressEvent('50%');
        ;
        trackingFlags.half = true;
      }

      // Track 75% played
      if (progress >= 75 && !trackingFlags.threeQuarters) {
        sendGTMProgressEvent('75%');
        trackingFlags.threeQuarters = true;
      }
    });

    // Reset tracking flags if audio is restarted
    audioElement.addEventListener('seeked', function () {
      if (audioElement.currentTime < 1) {
        // If user seeks to beginning
        trackingFlags.quarter = false;
        trackingFlags.half = false;
        trackingFlags.threeQuarters = false;
        trackingFlags.complete = false;
      }
    });

    // Handle play/pause
    playButton.addEventListener('click', function () {
      if (audioElement.paused) {
        audioElement.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
      }
    });
    pauseButton.addEventListener('click', function () {
      if (!audioElement.paused || audioElement.currentTime == audioElement.duration) {
        audioElement.pause();
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
      }
    });
    nextButton.addEventListener('click', function () {
      var currentTime = audioElement.currentTime;
      audioElement.currentTime = currentTime < audioElement.duration - 30 ? currentTime + 30 : audioElement.duration;
    });
    previousButton.addEventListener('click', function () {
      var currentTime = audioElement.currentTime;
      audioElement.currentTime = currentTime >= 30 ? currentTime - 30 : 0;
    });
    volumeControl.addEventListener('click', function () {
      if (audioElement.muted) {
        audioElement.muted = false;
        volumeOffSvg.style.display = 'none';
        volumeOnSvg.style.display = 'block';
      } else {
        audioElement.muted = true;
        volumeOffSvg.style.display = 'block';
        volumeOnSvg.style.display = 'none';
      }
    });

    // Handle progress bar clicks
    progressBar.addEventListener('click', function (e) {
      var rect = progressBar.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var percentage = x / rect.width;
      var time = percentage * audioElement.duration;
      audioElement.currentTime = time;
      progressFill.style.width = "".concat(percentage * 100, "%");
    });
    audioElement.addEventListener("ended", function () {
      playButton.style.display = 'block';
      pauseButton.style.display = 'none';
      if (!trackingFlags.complete) {
        sendGTMProgressEvent('watch to end');
        trackingFlags.complete = true;
      }
    });
  });
});

},{}],7:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('.carousel-block');
  if (carousels.length === 0) return;
  carousels.forEach(function (carousel) {
    var thumbnails = document.querySelectorAll('.thumbnail-li');
    var slideCount = thumbnails.length;
    var prevButton = document.querySelector('.prev');
    var nextButton = document.querySelector('.next');
    var indicator = document.querySelector('.slide-indicator-text');
    var activeContainer = document.querySelector('#carousel-active-container');
    var thumbnailContainer = document.querySelector('.thumbnail-container');
    var currentSlide = 0;
    function scrollToThumbnail(thumbnail) {
      var containerWidth = thumbnailContainer.offsetWidth;
      var thumbnailRect = thumbnail.getBoundingClientRect();
      var containerRect = thumbnailContainer.getBoundingClientRect();

      // Calculate if the thumbnail is partially or fully outside the container
      var isPartiallyVisible = thumbnailRect.left < containerRect.left || thumbnailRect.right > containerRect.right;
      if (isPartiallyVisible) {
        // Calculate the scroll position to center the thumbnail
        var scrollOffset = thumbnail.offsetLeft - (containerWidth - thumbnail.offsetWidth) / 2;
        thumbnailContainer.scrollTo({
          left: scrollOffset,
          behavior: 'smooth'
        });
      }
    }
    function showSlide(index) {
      var currentLi = thumbnails[index];
      var currentSlide = currentLi.querySelector('.slide-content');
      var activeLi = document.querySelector('.thumbnail-li.active');
      if (activeLi) activeLi.classList.remove('active');
      currentLi.classList.add('active');
      var clone = currentSlide.cloneNode(true);
      activeContainer.innerHTML = '';
      activeContainer.appendChild(clone);
      indicator.textContent = "".concat(index + 1, " of ").concat(slideCount);

      // Scroll the thumbnail into view
      scrollToThumbnail(currentLi);
    }
    prevButton.addEventListener('click', function () {
      currentSlide = currentSlide === 0 ? slideCount - 1 : currentSlide - 1;
      showSlide(currentSlide);
    });
    nextButton.addEventListener('click', function () {
      currentSlide = currentSlide === slideCount - 1 ? 0 : currentSlide + 1;
      showSlide(currentSlide);
    });
    thumbnails.forEach(function (thumb, index) {
      var button = thumb.querySelector('button');
      button.addEventListener('click', function () {
        currentSlide = index;
        showSlide(currentSlide);
        var pageTitle = button.getAttribute('data-gtm-page-title');
        window.dataLayer.push({
          'event': 'Action',
          'eventCategory': 'Click',
          'eventAction': "Click",
          'eventLabel': "".concat(pageTitle, " - Click"),
          'gtm.elementClasses': 'gtm-action'
        });
        window.dataLayer.push({
          'event': 'Action',
          'eventCategory': 'Click',
          'eventAction': "Click",
          'eventLabel': "".concat(pageTitle, " - Progression ").concat(index + 1, " of ").concat(slideCount),
          'gtm.elementClasses': 'gtm-action'
        });
      });
    });
  });
});

},{}],8:[function(require,module,exports){
"use strict";

var _prevent_scroll = require("./prevent_scroll.js");
var _gtm = require("./gtm.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ACCORDION_STATES_KEY = 'content_library_accordion_states';
var SCROLL_POSITION_KEY = 'content_library_scroll_position';
var SCROLL_TO_RESULTS_KEY = 'content_library_scroll_to_results';
var MOBILE_BREAKPOINT = 768;
document.addEventListener('DOMContentLoaded', function () {
  var contentLibrary = document.querySelector('.content-library[data-page-type="content-library"]');
  if (!contentLibrary) return;
  var mobileFilterButton = document.querySelector('.content-library_mobile-filter > button');
  var filterMenu = document.querySelector('.content-library_filters');
  var applyFiltersButton = document.getElementById('apply-filters');
  var filterTags = document.querySelectorAll('.filter_tag');
  var libraryAccordionItems = contentLibrary.querySelectorAll('.library-accordion-item');
  var paginationLinks = contentLibrary.querySelectorAll('.pagination-link');
  var states = JSON.parse(sessionStorage.getItem(ACCORDION_STATES_KEY)) || {};
  var isMobileView = window.innerWidth < MOBILE_BREAKPOINT;
  var selectedFilters = new Map(); // Store the selected filters for mobile view

  // Save accordion expand/collapse states to session storage in one object 
  var saveAccordionStates = function saveAccordionStates() {
    libraryAccordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (trigger && trigger.id) {
        // Store specific state instead of just expanded/collapsed
        if (trigger.classList.contains('active')) {
          states[trigger.id] = 'active';
        } else if (trigger.classList.contains('collapsed-active')) {
          states[trigger.id] = 'collapsed-active';
        } else {
          states[trigger.id] = null; // collapsed
        }
      }
    });
    sessionStorage.setItem(ACCORDION_STATES_KEY, JSON.stringify(states));
  };

  // Load accordion states from session storage
  var loadAccordionStates = function loadAccordionStates() {
    var statesIsEmpty = Object.keys(states).length === 0;
    libraryAccordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (statesIsEmpty) {
        // Set default state for first page load
        var defaultState = trigger.id === 'resource_types' || trigger.id === 'content_length' ? 'active' : null;
        if (trigger.id) states[trigger.id] = defaultState;

        // Apply default state
        if (defaultState === 'active') {
          trigger.setAttribute('aria-expanded', true);
          trigger.classList.add('active');
        } else {
          trigger.classList.remove('active');
          trigger.setAttribute('aria-expanded', false);
        }
      } else {
        var storedState = trigger.id ? states[trigger.id] : null;
        var isExpanded = storedState === 'active' || storedState === 'collapsed-active';
        trigger.setAttribute('aria-expanded', isExpanded);
        trigger.classList.remove('active', 'collapsed-active');
        if (storedState === 'active') {
          trigger.classList.add('active');
        } else if (storedState === 'collapsed-active') {
          trigger.classList.add('collapsed-active');
        }
      }

      // Apply the correct visual state for expanded content
      var expandedContent = trigger.nextElementSibling;
      if (expandedContent && trigger.getAttribute('aria-expanded') === 'true') {
        var allFilters = expandedContent.querySelectorAll('.filter_tag');
        var hasCheckedFilters = expandedContent.querySelectorAll('.filter_tag.checked').length > 0;

        // If in collapsed-active state, only show checked filters
        if (trigger.classList.contains('collapsed-active') && hasCheckedFilters) {
          allFilters.forEach(function (filter) {
            var filterItem = filter.closest('li');
            if (filterItem) filterItem.style.display = filter.classList.contains('checked') ? '' : 'none';
          });
        } else {
          allFilters.forEach(function (filter) {
            var filterItem = filter.closest('li');
            if (filterItem) filterItem.style.display = '';
          });
        }
      }
    });
    sessionStorage.setItem(ACCORDION_STATES_KEY, JSON.stringify(states));
  };

  // Save current scroll position to session storage
  var saveScrollPosition = function saveScrollPosition() {
    var scrollPosition = window.scrollY;
    sessionStorage.setItem(SCROLL_POSITION_KEY, scrollPosition.toString());
  };

  // Restore scroll position from session storag e
  var restoreScrollPosition = function restoreScrollPosition() {
    var savedPosition = sessionStorage.getItem(SCROLL_POSITION_KEY);
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      sessionStorage.removeItem(SCROLL_POSITION_KEY);
    }
  };

  // Handle accordion toggle
  var handleAccordionToggle = function handleAccordionToggle(trigger) {
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    var hasActiveClass = trigger.classList.contains('active');
    var hasCollapsedActiveClass = trigger.classList.contains('collapsed-active');
    var expandedContent = trigger.nextElementSibling;
    var isFacultyContributors = trigger.id === "faculty_contributors";
    if (!expandedContent) return;

    // Early return for 'sort_by' - only toggle active state
    if (trigger.id === 'sort_by') {
      trigger.classList.toggle('active');
      trigger.setAttribute('aria-expanded', !isExpanded);
      var _gtmAction = isExpanded ? 'Collapse' : 'Expand';
      (0, _gtm.sendGTMEvent)('Accordion', 'Accordion', _gtmAction, 'Sort by', 'gtm-accordion');
      return saveAccordionStates();
    }

    // Check if there are any checked filter tags within this accordion item
    var hasCheckedFilters = expandedContent.querySelectorAll('.filter_tag.checked').length > 0;

    // Case 1: Accordion has 'collapsed-active' class (showing only checked filters)
    if (hasCollapsedActiveClass) {
      // Show all filters - switch back to fully expanded view
      var allFilters = expandedContent.querySelectorAll('.filter_tag');
      allFilters.forEach(function (filter) {
        var filterItem = filter.closest('li');
        if (filterItem) {
          filterItem.style.display = '';
        }
      });

      // Switch classes
      trigger.classList.remove('collapsed-active');
      trigger.classList.add('active');

      // Keep expanded state
      trigger.setAttribute('aria-expanded', true);
    }
    // Case 2: Accordion has 'active' class and checked filters
    else if (hasActiveClass && hasCheckedFilters) {
      // Switch to 'collapsed-active' state - show only checked filters
      trigger.classList.remove('active');
      trigger.classList.add('collapsed-active');
      var child = trigger.nextElementSibling.querySelector('.accordion-trigger');
      if (child) {
        child.classList.remove('active', 'collapsed-active');
        child.classList.add('collapsed-active');
        child.setAttribute('aria-expanded', true);
      }

      // Keep expanded state
      trigger.setAttribute('aria-expanded', true);

      // Show only checked filters
      var _allFilters = expandedContent.querySelectorAll('.filter_tag');
      _allFilters.forEach(function (filter) {
        var filterItem = filter.closest('li');
        if (filterItem) filterItem.style.display = filter.classList.contains('checked') ? '' : 'none';
      });
    }
    // Case 3: Accordion has 'active' class but no checked filters - collapse it
    else if (hasActiveClass && !hasCheckedFilters) {
      // Collapse
      trigger.classList.remove('active');
      trigger.setAttribute('aria-expanded', false);
      var _child = trigger.nextElementSibling.querySelector('.accordion-trigger');
      if (_child) {
        _child.classList.remove('active', 'collapsed-active');
        _child.setAttribute('aria-expanded', false);
      }
    }

    // Case 4: Accordion is collapsed - expand it
    else {
      // Expand
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', true);

      // Ensure all filters are visible
      var _allFilters2 = expandedContent.querySelectorAll('.filter_tag');
      _allFilters2.forEach(function (filter) {
        var filterItem = filter.closest('li');
        if (filterItem) {
          filterItem.style.display = '';
        }
      });
    }
    var copy = trigger.querySelector('h3') ? trigger.querySelector('h3').innerText : trigger.querySelector('p').innerText;
    var gtmAction = isExpanded ? 'Collapse' : 'Expand';
    (0, _gtm.sendGTMEvent)('Accordion', 'Accordion', gtmAction, "Filter - ".concat(copy), 'gtm-accordion');
    saveAccordionStates();
  };

  // Setup accordion triggers
  var setupAccordionTriggers = function setupAccordionTriggers() {
    libraryAccordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (!trigger || !trigger.parentNode) return;

      // Remove existing event listeners
      var newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);
      newTrigger.addEventListener('click', function (e) {
        handleAccordionToggle(newTrigger);
        saveScrollPosition();
      });
    });
  };

  // Helper function to parse filters from URL
  var parseFiltersFromUrl = function parseFiltersFromUrl() {
    var url = window.location.href;
    var params = new URLSearchParams(url.split('?')[1] || '');

    // Clear existing selections
    selectedFilters.clear();

    // Loop through all params and add to selectedFilters map
    var _iterator = _createForOfIteratorHelper(params.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        if (key === 'page' || !value) continue;
        var values = value.split(',');
        selectedFilters.set(key, values);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  // Toggle mobile view when filter button is clicked
  mobileFilterButton.addEventListener('click', function () {
    saveScrollPosition();
    filterMenu.classList.add('filter-mobile-view');
    _prevent_scroll.toggleScroll.prevent(); // Prevent body scrolling when modal is open
  });

  // Handle close button
  var closeButton = document.getElementById('close-filters');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      filterMenu.classList.remove('filter-mobile-view');
      _prevent_scroll.toggleScroll.allow(); // Restore body scrolling
    });
  }

  // Handle back button
  var backButton = document.getElementById('back-to-content');
  if (backButton) {
    backButton.addEventListener('click', function () {
      filterMenu.classList.remove('filter-mobile-view');
      _prevent_scroll.toggleScroll.allow();
      if (mobileFilterButton) {
        setTimeout(function () {
          mobileFilterButton.focus();
        }, 100);
      }
    });
  }

  // Handle window resize to detect mobile/desktop change
  window.addEventListener('resize', function () {
    var wasMobileView = isMobileView;
    isMobileView = window.innerWidth < MOBILE_BREAKPOINT;

    // If transitioning between views, update behavior
    if (wasMobileView !== isMobileView) {
      // Clear session storage when switching views
      sessionStorage.removeItem(ACCORDION_STATES_KEY);
      sessionStorage.removeItem(SCROLL_POSITION_KEY);
      sessionStorage.removeItem(SCROLL_TO_RESULTS_KEY);
      setupFilterBehavior();

      // If switching from mobile to desktop and filter modal is open, close it
      if (wasMobileView && !isMobileView) {
        filterMenu.classList.remove('filter-mobile-view');
        _prevent_scroll.toggleScroll.allow();
      }
    }
  });

  // Function to construct URL with current filter state
  var constructFilterUrl = function constructFilterUrl() {
    var baseUrl = window.location.pathname;
    var params = new URLSearchParams();

    // Add each filter to URL parameters
    selectedFilters.forEach(function (values, key) {
      if (values.length > 0) {
        params.set(key, values.join(','));
      }
    });
    return params.toString() ? "".concat(baseUrl, "?").concat(params.toString()) : baseUrl;
  };

  // Apply filters and navigate
  var applyFilters = function applyFilters() {
    saveAccordionStates();
    window.location.href = constructFilterUrl();
  };

  // Setup filter tag clicks based on current view (mobile/desktop)
  var setupFilterBehavior = function setupFilterBehavior() {
    filterTags.forEach(function (tag) {
      // Check if tag and parentNode exist before trying to replace
      if (!tag || !tag.parentNode) {
        console.warn('Filter tag or its parent node is missing');
        return;
      }

      // Remove existing event listeners
      var newTag = tag.cloneNode(true);
      tag.parentNode.replaceChild(newTag, tag);

      // Get filter info
      var href = newTag.getAttribute('href');
      var isChecked = newTag.classList.contains('checked');

      // Extract filter key and value from the URL
      var filterKey, filterValue;
      try {
        // Parse the href to extract key and value
        var url = new URL(href, window.location.origin);
        var path = url.pathname;
        var searchParams = new URLSearchParams(url.search);

        // Find the parameter that changed from the current URL
        var currentParams = new URLSearchParams(window.location.search);
        var _iterator2 = _createForOfIteratorHelper(searchParams.entries()),
          _step2;
        try {
          var _loop = function _loop() {
            var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              value = _step2$value[1];
            var currentValue = currentParams.get(key);
            if (currentValue !== value) {
              filterKey = key;

              // The value may be a comma-separated list, so we need to determine
              // which value was added or removed
              if (currentValue) {
                var currentValues = currentValue.split(',');
                var newValues = value.split(',');

                // Find values that were added or removed
                if (newValues.length > currentValues.length) {
                  // A value was added
                  filterValue = newValues.find(function (v) {
                    return !currentValues.includes(v);
                  });
                } else {
                  // A value was removed
                  filterValue = currentValues.find(function (v) {
                    return !newValues.includes(v);
                  });
                }
              } else {
                // This is a new filter
                filterValue = value;
              }
              return 1; // break
            }
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            if (_loop()) break;
          }

          // If we couldn't find a changed parameter, it might be removing a parameter
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (!filterKey) {
          var _iterator3 = _createForOfIteratorHelper(currentParams.entries()),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                key = _step3$value[0],
                value = _step3$value[1];
              if (!searchParams.has(key)) {
                filterKey = key;
                filterValue = value.split(',')[0]; // Just take the first value
                break;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (e) {
        console.error('Error parsing filter URL:', e);
        return;
      }

      // Setup behavior based on view
      if (isMobileView) {
        // In mobile view, toggle selected state without navigation
        newTag.addEventListener('click', function (e) {
          e.preventDefault();

          // Check if this is a sort filter
          var isSortFilter = newTag.closest('.sort.library-accordion-item');
          if (isSortFilter) {
            // For sort filters, uncheck all other sort filters first
            var sortContainer = newTag.closest('.sort.library-accordion-item');
            var allSortTags = sortContainer.querySelectorAll('.filter_tag');
            allSortTags.forEach(function (tag) {
              tag.classList.remove('checked');
              tag.setAttribute('aria-checked', 'false');
            });

            // Then check this one
            newTag.classList.add('checked');
            newTag.setAttribute('aria-checked', 'true');

            // Handle sort filter selection
            handleSortFilterSelection(newTag);
          } else {
            // For non-sort filters
            var accordionItem = newTag.closest('.library-accordion-item');
            var trigger = accordionItem ? accordionItem.querySelector('.accordion-trigger') : null;
            var isCollapsedActive = trigger ? trigger.classList.contains('collapsed-active') : false;

            // Check if this is an unchecking action in collapsed-active mode
            if (isCollapsedActive && newTag.classList.contains('checked')) {
              var allCheckedFilters = Array.from(accordionItem.querySelectorAll('.filter_tag.checked'));
              var remainingCheckedFilters = allCheckedFilters.filter(function (tag) {
                return tag !== newTag;
              }).length;
              if (remainingCheckedFilters === 0) {
                if (trigger && trigger.id) {
                  states[trigger.id] = null;
                }
                trigger.classList.remove('collapsed-active');
                trigger.classList.remove('active');
                trigger.setAttribute('aria-expanded', false);
              } else {
                // Otherwise keep the collapsed-active state
                if (trigger && trigger.id) {
                  states[trigger.id] = 'collapsed-active';
                }
              }

              // Create the URL without this filter
              var _href = newTag.getAttribute('href');

              // Save states and navigate
              saveAccordionStates(); // Save all accordion states
              saveScrollPosition();
            }

            // Normal behavior for all other cases
            newTag.classList.toggle('checked');
            if (newTag.classList.contains('checked')) {
              newTag.setAttribute('aria-checked', 'true');
            } else {
              newTag.setAttribute('aria-checked', 'false');
            }

            // Update selectedFilters map
            if (filterKey && filterValue) {
              var values = selectedFilters.get(filterKey) || [];
              if (newTag.classList.contains('checked')) {
                // Add value if not already present
                if (!values.includes(filterValue)) {
                  values.push(filterValue);
                }
              } else {
                // Remove value
                values = values.filter(function (v) {
                  return v !== filterValue;
                });
              }
              if (values.length > 0) {
                selectedFilters.set(filterKey, values);
              } else {
                selectedFilters["delete"](filterKey);
              }
            }
          }
          if (newTag.closest('.sort.library-accordion-item')) {
            (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', newTag.innerText, 'gtm-action');
          } else {
            var copy;
            var el = newTag.closest('.library-accordion-item');
            if (el.classList.contains('faculty-filter_wrapper')) copy = 'Faculty Contributors';else if (el.classList.contains('topics-trigger')) copy = 'Resource Topic';else copy = el.querySelector('h3').innerText;
            (0, _gtm.sendGTMEvent)('Filter', 'Filter', 'Click', "".concat(copy, " - ").concat(newTag.innerText), 'gtm-filter');
          }
        });
      } else {
        // In desktop view, save accordion states and scroll position before navigation
        newTag.addEventListener('click', function (e) {
          // For non-sort filters
          var accordionItem = newTag.closest('.library-accordion-item');
          var trigger = accordionItem ? accordionItem.querySelector('.accordion-trigger') : null;
          var isCollapsedActive = trigger ? trigger.classList.contains('collapsed-active') : false;

          // Check if this is an unchecking action in collapsed-active mode
          if (isCollapsedActive && newTag.classList.contains('checked')) {
            var allCheckedFilters = Array.from(accordionItem.querySelectorAll('.filter_tag.checked'));
            var remainingCheckedFilters = allCheckedFilters.filter(function (tag) {
              return tag !== newTag;
            }).length;
            if (remainingCheckedFilters === 0) {
              if (trigger && trigger.id) {
                states[trigger.id] = null;
              }
              trigger.classList.remove('collapsed-active');
              trigger.classList.remove('active');
              trigger.setAttribute('aria-expanded', false);
            } else {
              // Otherwise keep the collapsed-active state
              if (trigger && trigger.id) {
                states[trigger.id] = 'collapsed-active';
              }
            }
          }
          // Check if this is a sort filter
          if (newTag.closest('.sort.library-accordion-item')) {
            e.preventDefault();
            (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', newTag.innerText, 'gtm-action');
            handleSortFilterSelection(newTag);
          } else {
            // For non-sort filters, save accordion states and scroll position before navigation
            saveAccordionStates();
            saveScrollPosition();
            var copy;
            var el = newTag.closest('.library-accordion-item');
            if (el.classList.contains('faculty-filter_wrapper')) copy = 'Faculty Contributors';else if (el.classList.contains('topics-trigger')) copy = 'Resource Topic';else copy = el.querySelector('h3').innerText;
            (0, _gtm.sendGTMEvent)('Filter', 'Filter', 'Click', "".concat(copy, " - ").concat(newTag.innerText), 'gtm-filter');
          }
        });
      }
    });
  };
  if (applyFiltersButton) {
    applyFiltersButton.addEventListener('click', applyFilters);
  }

  // Clear filters handler
  var clearAllLink = document.getElementById('clear-all');
  if (clearAllLink) {
    clearAllLink.addEventListener('click', function (e) {
      // Save accordion states before clearing filters
      saveAccordionStates();
      if (isMobileView) {
        e.preventDefault();
        // Clear all filter tags
        document.querySelectorAll('.filter_tag').forEach(function (tag) {
          tag.classList.remove('checked');
          tag.setAttribute('aria-checked', 'false');
        });

        // Clear the selectedFilters map
        selectedFilters.clear();
      }
      // In desktop mode, just save the scroll position and let the link work
      else {
        saveScrollPosition();
      }
      (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', 'Clear All', 'gtm-action');
    });
  }
  if (paginationLinks && paginationLinks.length > 0) {
    paginationLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var wrapper = document.querySelector('.content-library_wrapper');
        var wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
        sessionStorage.setItem(SCROLL_POSITION_KEY, wrapperTop.toString());
        (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', "Page Number - ".concat(link.innerText), 'gtm-action');
        window.location.href = link.href;
      });
    });
  }

  // Function to handle sort filter selection
  var handleSortFilterSelection = function handleSortFilterSelection(sortTag) {
    // Extract sort value from URL or data attribute
    var sortValue;

    // Try to get sort value from data attribute first (for mobile)
    sortValue = sortTag.getAttribute('data-filter-value');

    // If not available, try to extract from href (for desktop)
    if (!sortValue) {
      var href = sortTag.getAttribute('href');
      try {
        var url = new URL(href, window.location.origin);
        var urlParams = new URLSearchParams(url.search);
        sortValue = urlParams.get('sort');
      } catch (e) {
        console.error('Error parsing sort URL:', e);
        return;
      }
    }
    if (sortValue) {
      // Update URL by modifying only the sort parameter
      var currentUrl = new URL(window.location.href);
      var searchParams = currentUrl.searchParams;

      // Set the sort parameter
      searchParams.set('sort', sortValue);

      // Update the URL
      currentUrl.search = searchParams.toString();

      // Save state and redirect
      saveAccordionStates();
      saveScrollPosition();
      window.location.href = currentUrl.toString();
    }
  };

  // Handle clicks outside of sort dropdown
  document.addEventListener('click', function (event) {
    var sortDropdowns = document.querySelectorAll('.sort.library-accordion-item');
    if (!sortDropdowns.length) return;
    sortDropdowns.forEach(function (sortDropdown) {
      var sortButton = sortDropdown.querySelector('.accordion-trigger');
      var isActive = sortButton.classList.contains('active');
      var isOutsideClick = !sortDropdown.contains(event.target);
      if (isActive && isOutsideClick) handleAccordionToggle(sortButton);
    });
  });

  // Initialize filter behavior based on current view
  setupFilterBehavior();

  // Setup accordion triggers
  setupAccordionTriggers();

  // Restore scroll position if available
  restoreScrollPosition();

  // Load saved accordion states
  loadAccordionStates();

  // Initialize filters from current URL
  parseFiltersFromUrl();
});

},{"./gtm.js":14,"./prevent_scroll.js":22}],9:[function(require,module,exports){
"use strict";

var _gtm = require("./gtm.js");
document.addEventListener('DOMContentLoaded', function () {
  var banner = document.querySelector('#cookie-banner');
  var bannerClose = banner.querySelector('.modal-close');
  var consentKeyName = 'mindtd_cookie_consent';
  var consentValue = localStorage.getItem(consentKeyName);
  var cookieLink = banner.querySelector('a');
  var trackLink = function trackLink(e) {
    (0, _gtm.sendGTMEvent)('Cookies', 'Cookies', 'Click', 'Cookie Policy', 'gtm-cookies');
  };
  var initiateCookieBanner = function initiateCookieBanner() {
    banner.style.display = 'block';
    document.body.style.paddingBottom = banner.offsetHeight + 'px';
    if (cookieLink) cookieLink.addEventListener('click', trackLink);
    bannerClose.addEventListener('click', function () {
      var data = {
        accepted: true,
        timestamp: new Date().getTime()
      };
      localStorage.setItem(consentKeyName, JSON.stringify(data));
      document.body.style.paddingBottom = 'unset';
      banner.style.display = 'none';
      if (cookieLink) cookieLink.removeEventListener('click', trackLink);
    });
  };
  var toggleCookieBanner = function toggleCookieBanner() {
    if (consentValue) {
      var _JSON$parse = JSON.parse(consentValue),
        timestamp = _JSON$parse.timestamp;
      var currentTime = new Date().getTime();
      var oneMonth = 30 * 24 * 60 * 60 * 1000;
      if (currentTime - timestamp > oneMonth) {
        initiateCookieBanner();
      }
    } else {
      initiateCookieBanner();
    }
  };
  toggleCookieBanner();
});

},{"./gtm.js":14}],10:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var blocks = document.querySelectorAll('.icons-section-block.style-two');
  if (!blocks) return;
  var setEqualHeights = function setEqualHeights() {
    blocks.forEach(function (block) {
      var cards = block.querySelectorAll('.item');
      if (!cards) return;
      var tallestInnerHeight = 0;
      cards.forEach(function (card) {
        var innerHeight = card.querySelector('.title').offsetHeight;
        if (innerHeight > tallestInnerHeight) tallestInnerHeight = innerHeight;
      });
      var wrappers = block.querySelectorAll('.title-wrapper');
      if (!wrappers) return;
      wrappers.forEach(function (wrapper) {
        wrapper.style.minHeight = tallestInnerHeight + 'px';
      });
    });
  };
  setEqualHeights();
  window.addEventListener('resize', setEqualHeights);
});

},{}],11:[function(require,module,exports){
"use strict";

var _prevent_scroll = require("./prevent_scroll");
document.addEventListener('DOMContentLoaded', function () {
  var exitModal = document.getElementById('exit-modal');
  var exitModalClose = exitModal.querySelectorAll('.cancel-exit');
  var exitModalContinue = exitModal.querySelector('#exit-continue');

  // handle modal close buttons
  exitModalClose.forEach(function (close) {
    close.addEventListener('click', function () {
      exitModal.close();
      _prevent_scroll.toggleScroll.allow();
    });
  });

  // close modal on 'continue'
  exitModalContinue.addEventListener('click', function () {
    exitModal.close();
    _prevent_scroll.toggleScroll.allow();
  });
  var externalLinks = document.querySelectorAll('a[href*="://"]:not(.share-link)');

  // this is an array in case, like neurocrine.com, mulitple domains are considered 'same domain'
  var allowed = [window.location.host, 'neurocrine.com', 'mindtd-staging.fcb.io', 'mindtd-staging-refresh.azurewebsites.net', 'mind-td.com'];

  // External urls w/ Global Exit Modal
  if (!externalLinks || externalLinks.length === 0) return;
  externalLinks.forEach(function (link) {
    // if the link is external, show the modal, inject the href
    link.addEventListener('click', function (e) {
      if (!allowed.some(function (v) {
        return link.href.includes(v);
      })) {
        e.preventDefault();
        exitModal.showModal();
        _prevent_scroll.toggleScroll.prevent();
        exitModalContinue.href = link.href;
      }
    });
  });
});

},{"./prevent_scroll":22}],12:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var facultyBlock = document.querySelector('.faculty-list-block');
  if (!facultyBlock) return;
  var url = window.location.href;
  var params = url.includes('faculty_group');
  var filterTags = document.querySelectorAll('.filter_tag');
  filterTags.forEach(function (tag) {
    if (tag.innerHTML.trim().toLowerCase() === 'all') {
      tag.classList.add('filter_tag_all');
      tag.href = '?faculty_group=all';
      if (!params) {
        tag.classList.add('checked');
      }
    }
    tag.addEventListener('click', function (e) {
      sessionStorage.setItem('faculty_scroll_position', window.scrollY);
    });
  });
  var scrollPosition = sessionStorage.getItem('faculty_scroll_position');
  if (scrollPosition) {
    window.scrollTo(0, scrollPosition);
    sessionStorage.removeItem('faculty_scroll_position');
  }
});

},{}],13:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _prevent_scroll = require("./prevent_scroll.js");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener('DOMContentLoaded', function () {
  var modal = document.querySelector("#faculty-modal");
  var closeBtn = modal.querySelector('.closeModal');
  var scrollContainer = modal.querySelector('.scroll-container');

  // Check for modal Triggers
  var biographyLinks = document.querySelectorAll('a[href*="#"][href*="-biography"]');
  if (!biographyLinks || biographyLinks.length === 0) return;
  var hasScrolled = false;
  var trackScroll = function trackScroll() {
    if (!hasScrolled && scrollContainer.scrollTop > 0) {
      hasScrolled = true;
      window.dataLayer.push({
        'event': "Action",
        'eventCategory': "Action",
        'eventAction': "Scroll",
        'eventLabel': modal.querySelector('#faculty-title').innerText + ' ' + modal.querySelector('#faculty-credentials').innerText,
        'gtm.elementClasses': 'gtm-action'
      });
    }
  };
  biographyLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (link.closest('.faculty-list-tiles')) {
        window.dataLayer.push({
          'event': "Internal Link",
          'eventCategory': "Internal Link",
          'eventAction': "Click",
          'eventLabel': link.getAttribute('data-full-name'),
          'gtm.elementClasses': 'gtm-action'
        });
      }

      // Instead of changing the URL hash, directly load the faculty data
      // This prevents adding an entry to browser history
      var facultySlug = link.getAttribute('href').replace('#', '');
      loadFacultyData(facultySlug);
    });
  });
  // Close Modal
  closeBtn.addEventListener('click', function () {
    var name = modal.querySelector('#faculty-title').innerText + ' ' + modal.querySelector('#faculty-credentials').innerText;
    window.dataLayer.push({
      'event': "Action",
      'eventCategory': "Action",
      'eventAction': "Close",
      'eventLabel': name,
      'gtm.elementClasses': 'gtm-action'
    });
    modal.close();
    _prevent_scroll.toggleScroll.allow();
    hasScrolled = false;
    scrollContainer.removeEventListener('scroll', trackScroll);
    scrollContainer.removeEventListener('touchmove', trackScroll);

    // If the URL has a hash, remove it without adding to history
    if (window.location.hash && window.location.hash.includes('-biography')) {
      history.replaceState(null, document.title, window.location.pathname);
    }
  });

  // API Call + Inject Faculty Data
  var loadFacultyData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(hashSlug) {
      var response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            modal.querySelector('#faculty-photo').src = '';
            _context.next = 4;
            return fetch("/faculty/".concat(hashSlug));
          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();
          case 7:
            data = _context.sent;
            if (!data.error) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            displayFacultyData(data);
            modal.showModal();
            _prevent_scroll.toggleScroll.prevent();
            scrollContainer.scrollTop = 0;
            scrollContainer.addEventListener('scroll', trackScroll);
            scrollContainer.addEventListener('touchmove', trackScroll);
            _context.next = 21;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            console.error('Error loading faculty data:', _context.t0);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 18]]);
    }));
    return function loadFacultyData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // Function to display faculty data in the modal
  function displayFacultyData(data) {
    var _data$titles;
    modal.querySelector('#faculty-photo').src = data.photo || '';
    modal.querySelector('#faculty-credentials').textContent = data.credentials;
    modal.querySelector('#faculty-title').textContent = "".concat(data.first_name, " ").concat(data.middle_initial ? data.middle_initial : '', " ").concat(data.last_name);

    // biography is an optional field in cms
    if (data.biography) modal.querySelector('#faculty-biography').innerHTML = data.biography;else modal.querySelector('#faculty-biography').style.display = 'none';
    if ((data === null || data === void 0 || (_data$titles = data.titles) === null || _data$titles === void 0 ? void 0 : _data$titles.length) === 0) return;

    // Loop through titles array append list items
    var titlesList = modal.querySelector('#faculty-titles');
    titlesList.innerHTML = "";
    data.titles.forEach(function (title) {
      var titleItem = document.createElement('li');
      titleItem.className = 'button-text text-green weight-600 bg-seafoam border-radius-16';
      titleItem.innerHTML = title.title;
      if (title.location) {
        titleItem.innerHTML += title.location;
      }
      titlesList.appendChild(titleItem);
    });
  }

  // Handle hash changes
  var handleHashChange = function handleHashChange() {
    var currentHash = window.location.hash.replace('#', '').replace('/', '');
    if (currentHash && currentHash.includes('-biography')) {
      loadFacultyData(currentHash);
    } else {
      modal.close();
      _prevent_scroll.toggleScroll.allow();
      hasScrolled = false;
      scrollContainer.removeEventListener('scroll', trackScroll);
      scrollContainer.removeEventListener('touchmove', trackScroll);
    }
  };

  // Listen for hash changes
  window.addEventListener('hashchange', handleHashChange);

  // Check for hash on page load
  handleHashChange();
});

},{"./prevent_scroll.js":22}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendGTMEvent = sendGTMEvent;
document.addEventListener('DOMContentLoaded', function () {
  // Find all elements with GTM data attributes
  var gtmElements = document.querySelectorAll('[data-gtm-event-name]');

  // Add click event listeners to each element
  gtmElements.forEach(function (element) {
    element.addEventListener('click', function () {
      // Get data from the attributes
      var eventName = this.getAttribute('data-gtm-event-name');
      var eventCategory = this.getAttribute('data-gtm-event-category');
      var eventAction = this.getAttribute('data-gtm-event-action');
      var eventLabel = this.getAttribute('data-gtm-event-label');
      var classes = this.className;
      sendGTMEvent(eventName, eventCategory, eventAction, eventLabel, classes);
    });
  });
});
function sendGTMEvent(eventName, eventCategory, eventAction, eventLabel, classes) {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }
  window.dataLayer.push({
    'event': eventName,
    'eventCategory': eventCategory,
    'eventAction': eventAction,
    'eventLabel': eventLabel,
    'gtm.elementClasses': classes,
    'pageURL': window.location.href,
    'pagePath': window.location.pathname
  });
}

},{}],15:[function(require,module,exports){
"use strict";

var _gtm = require("./gtm.js");
document.addEventListener('DOMContentLoaded', function () {
  // Save data to sessionStorage
  var dismissableBanners = document.querySelectorAll('.dismissable');
  if (!dismissableBanners) return;
  dismissableBanners.forEach(function (banner, index) {
    banner.style.display = 'none';
    var hideBanner = sessionStorage.getItem("hideBanner" + index);
    if (!hideBanner) banner.style.display = 'block';
    var dismissButton = banner.querySelector('.dismiss-block');
    if (dismissButton) {
      dismissButton.addEventListener('click', function () {
        var linkLabel = 'Close';
        var link = banner.querySelector('.button-block');
        if (link) linkLabel = link.innerText;
        banner.style.display = 'none';
        sessionStorage.setItem("hideBanner" + index, true);
        (0, _gtm.sendGTMEvent)('Action', 'Action', 'Click', linkLabel, 'gtm-action');
      });
    }
  });
});

},{"./gtm.js":14}],16:[function(require,module,exports){
"use strict";

require("./gtm");
require("./navigation");
require("./assessment");
require("./header_banner");
require("./audio_player");
require("./cookie_banner");
require("./exit_modal");
require("./accordion");
require("./videos");
require("./share_links");
require("./landing_modal");
require("./faculty_modal");
require("./carousel");
require("./faculty_filter");
require("./interactive_journey");
require("./question.js");
require("./content_library_filter.js");
require("./equal_heights.js");
require("./search.js");
require("./pdf_viewer.js");
require("./rich_text_gtm.js");
require("./navigation_history.js");

},{"./accordion":4,"./assessment":5,"./audio_player":6,"./carousel":7,"./content_library_filter.js":8,"./cookie_banner":9,"./equal_heights.js":10,"./exit_modal":11,"./faculty_filter":12,"./faculty_modal":13,"./gtm":14,"./header_banner":15,"./interactive_journey":17,"./landing_modal":18,"./navigation":19,"./navigation_history.js":20,"./pdf_viewer.js":21,"./question.js":23,"./rich_text_gtm.js":24,"./search.js":25,"./share_links":26,"./videos":27}],17:[function(require,module,exports){
"use strict";

var _prevent_scroll = require("./prevent_scroll");
document.addEventListener('DOMContentLoaded', function () {
  var journey = document.querySelector('.journey-block');
  if (!journey) return;
  var stepCards = document.querySelectorAll(".step-card, .opening-modal");
  var sendGTMEvent = function sendGTMEvent(label, action) {
    window.dataLayer.push({
      'event': "Action",
      'eventCategory': "Action",
      'eventAction': action,
      'eventLabel': label,
      'gtm.elementClasses': 'gtm-action'
    });
  };
  stepCards.forEach(function (card) {
    var trigger = card.querySelector('.modal-trigger');
    var dialog = card.querySelector('dialog');
    var close = dialog.querySelector('.close-modal');
    var tabButtons = dialog.querySelectorAll('.tab-buttons');
    var tabPanels = dialog.querySelectorAll('.tab-panel');
    var scrollContainer = dialog.querySelector('.scroll-container');
    var currentTabIndex = 0;
    var hasScrolled = false;
    var trackScroll = function trackScroll(buttonTitle) {
      return function () {
        if (!hasScrolled && scrollContainer.scrollTop > 0) {
          hasScrolled = true;
          sendGTMEvent(buttonTitle, 'Scroll');
        }
      };
    };
    var activateTab = function activateTab(button) {
      var panelId = button.getAttribute('data-panel');
      var panel = document.getElementById(panelId);
      var buttonTitle = button.getAttribute('data-gtm-title');
      tabButtons.forEach(function (btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
        scrollContainer.removeEventListener('scroll', trackScroll());
        scrollContainer.removeEventListener('touchmove', trackScroll());
      });
      tabPanels.forEach(function (p) {
        p.style.display = p.id === panelId ? 'block' : 'none';
      });
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      scrollContainer.scrollTop = 0;
      hasScrolled = false;
      scrollContainer.addEventListener('scroll', trackScroll(buttonTitle, 'Scroll'));
      scrollContainer.addEventListener('touchmove', trackScroll(buttonTitle, 'Scroll'));
    };
    tabButtons.forEach(function (button, index) {
      var buttonTitle = button.getAttribute('data-gtm-title');
      button.addEventListener('click', function () {
        sendGTMEvent(buttonTitle, 'Click');
        activateTab(button);
      });
      button.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowLeft':
            if (currentTabIndex === 0) currentTabIndex = tabButtons.length - 1;else currentTabIndex--;
            tabButtons[currentTabIndex].focus();
            break;
          case 'ArrowRight':
            if (currentTabIndex === tabButtons.length - 1) currentTabIndex = 0;else currentTabIndex++;
            tabButtons[currentTabIndex].focus();
            break;
        }
      });
    });
    trigger.addEventListener('click', function () {
      dialog.showModal();
      _prevent_scroll.toggleScroll.prevent();
      activateTab(tabButtons[0]);
      sendGTMEvent(trigger.getAttribute('data-gtm-title'), 'Click');
      scrollContainer.scrollTop = 0;
      hasScrolled = false;
    });
    close.addEventListener('click', function () {
      scrollContainer.removeEventListener('scroll', trackScroll());
      scrollContainer.removeEventListener('touchmove', trackScroll());
      var activeTab = document.querySelector('.tab-buttons.active');
      if (activeTab) sendGTMEvent(activeTab.innerText, 'Close');
      dialog.close();
      _prevent_scroll.toggleScroll.allow();
    });
  });
});

},{"./prevent_scroll":22}],18:[function(require,module,exports){
"use strict";

var _prevent_scroll = require("./prevent_scroll");
document.addEventListener('DOMContentLoaded', function () {
  var landingModal = document.getElementById('landing-modal');
  var landingModalClose = landingModal.querySelectorAll('.close-btn');
  var canShow = landingModal.getAttribute('data-use');
  if (canShow === 'false') return;

  // check local storage and expiry date if found
  var storageName = 'mindtd_landing_msg';
  var storedValue = localStorage.getItem(storageName);
  if (storedValue) {
    var _JSON$parse = JSON.parse(storedValue),
      timestamp = _JSON$parse.timestamp;
    var currentTime = new Date().getTime();
    var oneMonth = 30 * 24 * 60 * 60 * 1000;

    // show modal again after 1 month passes
    if (currentTime - timestamp > oneMonth) {
      landingModal.showModal();
      _prevent_scroll.toggleScroll.prevent();
    }
  } else {
    landingModal.showModal();
    _prevent_scroll.toggleScroll.prevent();
  }

  // handle modal close buttons
  landingModalClose.forEach(function (close) {
    close.addEventListener('click', function () {
      var data = {
        accepted: true,
        timestamp: new Date().getTime()
      };
      localStorage.setItem(storageName, JSON.stringify(data));
      landingModal.close();
      _prevent_scroll.toggleScroll.allow();
    });
  });
});

},{"./prevent_scroll":22}],19:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var globalHeader = document.querySelector('.global-header');
  var hamburger = document.getElementById('hamburger-icon');
  var nav = document.querySelector('.primary-nav-inner');
  var dropdownButtons = document.querySelectorAll('.has-submenu button');
  var headerHeight = globalHeader.offsetHeight;
  var headerSpacer = document.querySelector('.header-spacer');
  var isMobile = window.innerWidth < 1025;
  var updateHeaderHeight = function updateHeaderHeight() {
    if (window.innerWidth < 1025) {
      headerSpacer.style.display = 'none';
      headerSpacer.style.height = '0px';
    } else {
      headerHeight = globalHeader.offsetHeight;
      headerSpacer.style.height = headerHeight + 'px';
    }
  };
  updateHeaderHeight();
  function detectScrollDirection(callback) {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var topThreshold = headerHeight;
    window.addEventListener('scroll', function () {
      var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollTop < lastScrollTop) {
        // Scrolling up
        if (currentScrollTop > 0) {
          headerSpacer.style.display = 'block';
          globalHeader.classList.add('sticky');
        }
      } else if (currentScrollTop > lastScrollTop) {
        // Scrolling down
        globalHeader.classList.remove('sticky');
        headerSpacer.style.display = 'none';
      }
      lastScrollTop = currentScrollTop;
    });
  }
  detectScrollDirection(function (direction) {
    // console.log(`Scrolling ${direction}`);
  });

  // Toggle mobile menu
  hamburger.addEventListener('click', function () {
    var isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);
    this.classList.toggle('button-active');
    nav.classList.toggle('active');
    if (!isExpanded) handleSubmenus();
    var label = nav.classList.contains('active') ? 'Menu Open' : 'Menu Close';
    window.dataLayer.push({
      'event': "Header",
      'eventCategory': "Header",
      'eventAction': "Click",
      'eventLabel': label,
      'gtm.elementClasses': 'gtm-header',
      'pageURL': window.location.href,
      'pagePath': window.location.pathname
    });
  });

  // Handle dropdown menus
  dropdownButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      // When a user manually clicks a submenu button, disable the auto-expand behavior
      sessionStorage.setItem('expand_submenu', 'false');
      var submenu = this.nextElementSibling;
      var isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Update ARIA states
      this.setAttribute('aria-expanded', !isExpanded);

      // Toggle the submenu
      submenu.classList.toggle('active');
    });
  });
  var menuItems = globalHeader === null || globalHeader === void 0 ? void 0 : globalHeader.querySelectorAll('.menu-item');
  menuItems.forEach(function (item) {
    var link = item.querySelector('a, button');
    var submenu = item.querySelector('.submenu');
    var submenuItems = submenu ? submenu.querySelectorAll('a') : [];
    var currentPath = window.location.pathname;
    function isCurrentPage(menuItem) {
      var menuLink = menuItem.tagName.toLowerCase() === 'a' ? menuItem : menuItem.querySelector('a');
      if (!menuLink) return false;
      var href = menuLink.getAttribute('href');
      if (href.startsWith('http') || href.startsWith('//')) return false;
      var menuPath = new URL(href, window.location.origin).pathname;
      if (menuPath === '/' && currentPath === '/') return true;
      return currentPath === menuPath;
    }
    function isParentPage(menuItem) {
      var menuLink = menuItem.tagName.toLowerCase() === 'a' ? menuItem : menuItem.querySelector('a');
      if (!menuLink) return false;
      var href = menuLink.getAttribute('href');
      if (!href) return false;
      if (href.startsWith('http') || href.startsWith('//')) return false;
      var menuPath = new URL(href, window.location.origin).pathname;
      if (menuPath === '/') return false;
      menuPath = menuPath.endsWith('/') ? menuPath : menuPath + '/';
      return currentPath.includes(menuPath) && !submenu;
    }
    var isActive = isCurrentPage(item);
    var isActiveParent = isParentPage(item);
    if (isActive) {
      if (!link.hasAttribute('aria-current')) {
        item.classList.add('current-dropdown');
        link.classList.add('current-page');
        link.setAttribute('aria-current', 'page');
      }
    } else if (isActiveParent) {
      link.classList.add('current-page');
    } else {
      link.classList.remove('current-page');
      item.classList.remove('current-dropdown');
      link.removeAttribute('aria-current');
    }

    // Keyboard navigation 
    link.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (submenu && !submenu.classList.contains('active')) {
            var _submenuItems$;
            submenu.classList.add('active');
            link.setAttribute('aria-expanded', 'true');
            (_submenuItems$ = submenuItems[0]) === null || _submenuItems$ === void 0 || _submenuItems$.focus();
          }
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (submenu && submenu.classList.contains('active')) {
            submenu.classList.remove('active');
            link.setAttribute('aria-expanded', 'false');
          }
          break;
      }
    });
    if (link.href) {
      link.addEventListener('click', function (e) {
        var event = link.closest('.sub-menu-item') ? 'Sub Navigation' : 'Top Navigation';
        window.dataLayer.push({
          'event': event,
          'eventCategory': event,
          'eventAction': "Click",
          'eventLabel': link.innerText,
          'gtm.elementClasses': 'gtm-top-nav'
        });
      });
    }
  });

  // Handle resize events
  window.addEventListener('resize', function () {
    isMobile = window.innerWidth < 1025;
    updateHeaderHeight();
  });

  // Handle ESC key to close mobile menu
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('active')) {
      nav.classList.remove('active');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.focus();
    }
  });

  // Handle click outside of dropdown to close
  document.addEventListener('click', function (e) {
    var dropdownSubmenu = document.querySelector('.submenu');
    if (!e.target.closest('.primary-nav-inner') && dropdownSubmenu.classList.contains('active')) {
      dropdownSubmenu.classList.remove('active');
    }
  });

  // Hack to bold the Libary in menu when resource page is not a child page of library
  var resourcePage = document.querySelector('.resource-page');
  var assessmentPage = document.querySelector('.assessment-page');
  var quizPage = document.querySelector('.quiz-page');
  var libraryLink = document.querySelector("[href=\"/library\"]");
  var islibrary = window.location.pathname === '/library' || window.location.pathname === '/library/';
  if (resourcePage || assessmentPage || quizPage || islibrary) {
    libraryLink.classList.add('current-page');
  } else {
    libraryLink.classList.remove('current-page');
  }
  headerSpacer.style.display = 'none';
  globalHeader.classList.remove('sticky');

  // Set default expand_submenu to true when page first loads
  if (sessionStorage.getItem('expand_submenu') === null) {
    sessionStorage.setItem('expand_submenu', 'true');
  }

  // Expand submenus that have a current page as a child (for mobile)
  var expandCurrentPageSubmenu = function expandCurrentPageSubmenu() {
    if (!isMobile) return;
    var currentItem = document.querySelector('a.current-page');
    var li = currentItem.closest('.has-submenu');
    if (!li) return;
    var submenu = li.querySelector('.submenu');
    var button = li.querySelector('button');
    button.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      submenu.classList.add('active');
    }, 50);
  };

  // Function to handle submenu expansion based on sessionStorage
  var handleSubmenus = function handleSubmenus() {
    var expand_submenu = sessionStorage.getItem('expand_submenu') === 'true';
    if (expand_submenu) {
      dropdownButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
        var submenu = button.nextElementSibling;
        setTimeout(function () {
          submenu.classList.add('active');
        }, 50);
      });
    }

    // Always expand submenus containing current page links on mobile
    expandCurrentPageSubmenu();
  };

  // Call expandCurrentPageSubmenu on page load
  expandCurrentPageSubmenu();
});

},{}],20:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  // Store the current URL as the previous URL when leaving the page
  window.addEventListener('beforeunload', function () {
    sessionStorage.setItem('previous_url', window.location.href);
  });

  // Check for back-to-library link
  var backToLibraryLink = document.getElementById('back-to-library-link');
  if (backToLibraryLink) {
    var previousUrl = sessionStorage.getItem('previous_url');

    // If there's a previous URL and it contains /library, use it for the back link
    if (previousUrl && previousUrl.includes('/library')) {
      backToLibraryLink.setAttribute('href', previousUrl);
    }
  }
});

},{}],21:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _gtm = require("./gtm.js");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener('DOMContentLoaded', function () {
  var pdfContainers = document.querySelectorAll('.pdf-container');
  if (!pdfContainers.length) return;

  // Initialize each PDF viewer
  pdfContainers.forEach(function (container, index) {
    var pdfUrl = container.dataset.pdfUrl;
    var pdfTitle = container.dataset.pdfTitle;
    if (!pdfUrl) return;
    var printBtn = container.querySelector('.pdfjs-button[data-action="print"]');
    var downloadBtn = container.querySelector('.pdfjs-button[data-action="download"]');
    var pageNumInput = container.querySelector('.page-num');
    var pageCount = container.querySelector('.page-count');

    // Clear any existing content in the content wrapper
    var contentWrapper = container.querySelector('.pdf-content-wrapper');
    contentWrapper.innerHTML = '';

    // Remove single canvas element if it exists
    var existingCanvas = container.querySelector('.pdf-render');
    if (existingCanvas) {
      existingCanvas.remove();
    }

    // Track the last visible page to detect changes
    var lastVisiblePage = 1;

    // Scroll Listener for GTM tracking and page number updates
    contentWrapper.addEventListener('scroll', function () {
      // Update current page number based on scroll position
      if (pageNumInput && pdfDoc) {
        var containerRect = contentWrapper.getBoundingClientRect();
        var pageContainers = contentWrapper.querySelectorAll('.pdf-page-container');
        var currentVisiblePage = 1;
        var highestVisibilityRatio = 0;

        // update current page
        pageContainers.forEach(function (pageEl) {
          var pageRect = pageEl.getBoundingClientRect();
          var pageNumber = parseInt(pageEl.dataset.pageNumber);
          var visibleTop = Math.max(pageRect.top, containerRect.top);
          var visibleBottom = Math.min(pageRect.bottom, containerRect.bottom);
          if (visibleBottom > visibleTop) {
            var visibleHeight = visibleBottom - visibleTop;
            var visibleRatio = visibleHeight / pageRect.height;
            if (visibleRatio > highestVisibilityRatio) {
              highestVisibilityRatio = visibleRatio;
              currentVisiblePage = pageNumber;
            }
          }
        });

        // Update input value if it's different from current value
        if (parseInt(pageNumInput.value) !== currentVisiblePage) {
          pageNumInput.value = currentVisiblePage;

          // Send GTM event for page change
          if (lastVisiblePage !== currentVisiblePage) {
            (0, _gtm.sendGTMEvent)('PDF', 'PDF', "Scroll ".concat(currentVisiblePage), pdfTitle, 'gtm-pdf');
            lastVisiblePage = currentVisiblePage;
          }
        }
      }
    });
    var pdfDoc = null;
    var scale = 1.5;

    // Adjust scale based on container width
    function calculateScale() {
      var containerWidth = container.clientWidth;
      var pixelRatio = window.devicePixelRatio || 1;
      if (containerWidth < 768) {
        scale = containerWidth / 550 * pixelRatio;
      } else {
        scale = containerWidth / 1200 * pixelRatio;
      }
      return Math.max(1.0, Math.min(scale, 2.5 * pixelRatio));
    }

    // Render page function
    function renderPage(page, pageNumber) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve) {
          var currentScale, pageContainer, canvasWrapper, canvas, ctx, viewport, pixelRatio, renderContext;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                currentScale = calculateScale(); // Create a page container 
                pageContainer = document.createElement('div');
                pageContainer.className = 'pdf-page-container';
                pageContainer.dataset.pageNumber = pageNumber;
                pageContainer.style.marginBottom = '20px';
                pageContainer.style.textAlign = 'center';

                // Create a wrapper div to maintain aspect ratio
                canvasWrapper = document.createElement('div');
                canvasWrapper.className = 'canvas-wrapper';
                canvasWrapper.style.display = 'inline-block';
                canvasWrapper.style.maxWidth = '98%';
                canvasWrapper.style.position = 'relative';
                pageContainer.appendChild(canvasWrapper);

                // Create canvas for this page
                canvas = document.createElement('canvas');
                canvas.className = 'pdf-render-page';
                canvas.id = "pdf-page-".concat(pageNumber);
                canvasWrapper.appendChild(canvas);

                // Add container to DOM
                contentWrapper.appendChild(pageContainer);

                // Get canvas context and viewport
                ctx = canvas.getContext('2d');
                viewport = page.getViewport({
                  scale: currentScale
                });
                pixelRatio = window.devicePixelRatio || 1; // Set canvas dimensions for rendering (high quality)
                canvas.height = viewport.height * pixelRatio;
                canvas.width = viewport.width * pixelRatio;
                canvasWrapper.style.width = viewport.width + 'px';
                canvas.style.width = '100%';
                canvas.style.height = 'auto';
                canvas.style.display = 'block';

                // Scale the context for high-DPI rendering
                ctx.scale(pixelRatio, pixelRatio);

                // Render PDF page with enhanced settings
                renderContext = {
                  canvasContext: ctx,
                  viewport: viewport,
                  enableWebGL: true,
                  renderInteractiveForms: true,
                  textLayer: true
                };
                _context.next = 30;
                return page.render(renderContext).promise;
              case 30:
                resolve();
              case 31:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    // Render all pages
    function renderAllPages() {
      return _renderAllPages.apply(this, arguments);
    } // Print function
    function _renderAllPages() {
      _renderAllPages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var i, page;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // // Show loading indicator
              // const loadingIndicator = document.createElement('div');
              // loadingIndicator.className = 'pdf-loading';
              // loadingIndicator.textContent = 'Loading PDF pages...';
              // loadingIndicator.style.textAlign = 'center';
              // loadingIndicator.style.padding = '20px';
              // contentWrapper.appendChild(loadingIndicator);
              if (pageNumInput) pageNumInput.value = 1;
              _context2.prev = 1;
              i = 1;
            case 3:
              if (!(i <= pdfDoc.numPages)) {
                _context2.next = 12;
                break;
              }
              _context2.next = 6;
              return pdfDoc.getPage(i);
            case 6:
              page = _context2.sent;
              _context2.next = 9;
              return renderPage(page, i);
            case 9:
              i++;
              _context2.next = 3;
              break;
            case 12:
              _context2.next = 17;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](1);
              console.error('Error rendering pages:', _context2.t0);
            case 17:
              _context2.prev = 17;
              return _context2.finish(17);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 14, 17, 19]]);
      }));
      return _renderAllPages.apply(this, arguments);
    }
    function printPDF() {
      if (!pdfDoc) return;
      var printFrame = document.createElement('iframe');
      printFrame.style.display = 'none';
      document.body.appendChild(printFrame);
      printFrame.src = pdfUrl;
      printFrame.onload = function () {
        setTimeout(function () {
          try {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            if (typeof window.afterprint !== 'undefined') {
              window.addEventListener('afterprint', function removeFrame() {
                document.body.removeChild(printFrame);
                window.removeEventListener('afterprint', removeFrame);
              });
            } else {
              // For browsers that don't support afterprint,
            }
          } catch (err) {
            console.error('Error printing from PDF:', err);
            window.open(pdfUrl, '_blank');
          }
        }, 1000);
      };
    }

    // Button events - print and download
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        var fallbackIframe = container.querySelector('.pdf-iframe-fallback');
        if (fallbackIframe) {
          try {
            fallbackIframe.contentWindow.focus();
            fallbackIframe.contentWindow.print();
          } catch (err) {
            console.error('Error printing from iframe:', err);
            window.open(pdfUrl, '_blank');
          }
        } else {
          printPDF();
        }
        (0, _gtm.sendGTMEvent)('PDF', 'PDF', 'Print', pdfTitle, 'gtm-pdf');
      });
    }
    if (downloadBtn) {
      downloadBtn.addEventListener('click', function () {
        (0, _gtm.sendGTMEvent)('PDF', 'PDF', 'Download', pdfTitle, 'gtm-pdf');
      });
    }

    // Function to handle page navigation using the input directly from HTML
    function setupPageNavigation(numPages) {
      if (!pageNumInput || !pageCount) return;
      pageCount.textContent = numPages;
      pageNumInput.value = 1;
      pageNumInput.addEventListener('change', function () {
        var pageNum = parseInt(this.value);
        if (isNaN(pageNum) || pageNum < 1) pageNum = 1;else if (pageNum > numPages) pageNum = numPages;
        this.value = pageNum;
        currentPage = pageNum;

        // Send GTM event for manual page change if it differs from last known page
        if (lastVisiblePage !== pageNum) {
          (0, _gtm.sendGTMEvent)('PDF', 'Manual Page Change', "Page ".concat(pageNum), pdfTitle, 'gtm-pdf-page-manual');
          lastVisiblePage = pageNum; // Update lastVisiblePage to avoid duplicate events during scroll
        }
        var pageEl = contentWrapper.querySelector(".pdf-page-container[data-page-number=\"".concat(pageNum, "\"]"));
        if (pageEl) {
          var containerRect = contentWrapper.getBoundingClientRect();
          var pageRect = pageEl.getBoundingClientRect();
          var relativeTop = pageRect.top - containerRect.top;
          contentWrapper.scrollTop = relativeTop + contentWrapper.scrollTop;
        }
      });
      pageNumInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') this.blur();
      });
      pageNumInput.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          var pageNum = parseInt(this.value) || 0;
          if (pageNum < numPages) {
            this.value = pageNum + 1;
            this.dispatchEvent(new Event('change'));
          }
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          var _pageNum = parseInt(this.value) || 2;
          if (_pageNum > 1) {
            this.value = _pageNum - 1;
            this.dispatchEvent(new Event('change'));
          }
        }
      });
    }

    // Load PDF
    function fallbackToEmbedded() {
      // Create an iframe fallback
      var iframe = document.createElement('iframe');
      iframe.src = pdfUrl;
      iframe.width = '100%';
      iframe.height = '500px';
      iframe.className = 'pdf-iframe-fallback';
      iframe.title = container.dataset.pdfTitle || 'PDF Document';
      iframe.allowFullscreen = true;
      iframe.onload = function () {
        iframe.contentWindow.addEventListener('scroll', function () {
          // console.log('scrolll');
        });
        if (pageCount) {
          try {
            pageCount.textContent = "?";
          } catch (e) {
            pageCount.textContent = "?";
          }
        }
      };

      // Append after the content wrapper
      container.appendChild(iframe);

      // Display success message
      var successMsg = document.createElement('div');
      successMsg.className = 'pdf-success';
      successMsg.textContent = 'PDF loaded in fallback viewer';
      successMsg.style.display = 'none'; // Hide the message but keep for debugging
      container.appendChild(successMsg);
    }
    try {
      window.pdfjsLib.getDocument({
        url: pdfUrl,
        withCredentials: true,
        cMapUrl: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/cmaps/',
        cMapPacked: true,
        disableAutoFetch: false,
        disableStream: false,
        disableFontFace: false,
        nativeImageDecoderSupport: 'display'
      }).promise.then(function (pdf) {
        pdfDoc = pdf;
        if (pageCount) pageCount.textContent = pdf.numPages;
        setupPageNavigation(pdf.numPages);
        if (pageNumInput) {
          pageNumInput.setAttribute('max', pdf.numPages);
        }

        // Render all pages at once
        renderAllPages();
      })["catch"](function (error) {
        console.error('Error loading PDF with PDF.js:', error);
        fallbackToEmbedded();
      });
    } catch (error) {
      console.error('Error initializing PDF.js:', error);
      fallbackToEmbedded();
    }
  });
});

},{"./gtm.js":14}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleScroll = void 0;
var toggleScroll = exports.toggleScroll = {
  scrollPosition: 0,
  scrollbarWidth: window.innerWidth - document.documentElement.clientWidth,
  prevent: function prevent() {
    // Store the current scroll position
    this.scrollPosition = window.scrollY;
    document.body.style.paddingRight = "".concat(this.scrollbarWidth, "px");
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'hidden';
  },
  allow: function allow() {
    // Restore scrolling
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.overflow = '';

    // Restore scroll position
    window.scrollTo(0, this.scrollPosition);
  }
};

},{}],23:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var questionBlock = document.querySelector('.question-block');
  if (!questionBlock) return;
  var form = questionBlock.querySelector('form');
  var question = document.querySelector('.question');
  var finalAnswerDiv = document.querySelector('.final-answer');
  var imageCorrect = document.querySelector('.image-correct');
  var imageIncorrect = document.querySelector('.image-incorrect');
  var textCorrect = document.querySelector('.text-correct');
  var textIncorrect = document.querySelector('.text-incorrect');
  var submitButton = form.querySelector('button');
  var checkboxes = form.querySelectorAll('input');

  // Add event listeners to all checkboxes
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      var isAnyChecked = Array.from(checkboxes).some(function (cb) {
        return cb.checked;
      });
      submitButton.disabled = !isAnyChecked;
    });
  });

  // Submit event for form
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var allSelectedAreCorrect = true;
    var allCorrectAreSelected = true;
    checkboxes.forEach(function (checkbox) {
      var isChecked = checkbox.checked;
      var isCorrect = checkbox.getAttribute('data-ans') === 'True';
      if (isChecked && !isCorrect || !isChecked && isCorrect) {
        if (isChecked) {
          allSelectedAreCorrect = false;
        }
        if (isCorrect) {
          allCorrectAreSelected = false;
        }
      }
    });
    question.style.display = 'none';
    finalAnswerDiv.style.display = 'flex';
    if (allSelectedAreCorrect && allCorrectAreSelected) {
      imageCorrect.style.display = 'block';
      textCorrect.style.display = 'block';
      imageIncorrect.style.display = 'none';
      textIncorrect.style.display = 'none';
    } else {
      imageCorrect.style.display = 'none';
      textCorrect.style.display = 'none';
      imageIncorrect.style.display = 'block';
      textIncorrect.style.display = 'block';
    }
  });
});

},{}],24:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var richBlocks = document.querySelectorAll('.rich-text');
  if (!richBlocks || richBlocks.length === 0) return;
  var doGTM = function doGTM(event, label, action) {
    window.dataLayer.push({
      'event': event,
      'eventCategory': event,
      'eventAction': "Click",
      'eventLabel': label,
      'gtm.elementClasses': action
    });
  };
  richBlocks.forEach(function (block) {
    var links = block.querySelectorAll('a');
    if (!links || links.length === 0) return;
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.target === '_blank') {
          doGTM('External Link', link.innerText, 'gtm-external-link');
        } else {
          doGTM('Internal Link', link.innerText, 'gtm-internal-link');
        }
      });
    });
  });
});

},{}],25:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var searchForm = document.querySelectorAll('.search-form');
  if (!searchForm) return;
  searchForm.forEach(function (form) {
    var searchLabel = form.querySelector('label');
    var searchInput = form.querySelector('input');
    if (searchInput && searchLabel) {
      searchInput.addEventListener('input', function () {
        if (searchInput.value.length > 0) searchLabel.style.opacity = '0';else searchLabel.style.opacity = '1';
      });
      if (searchInput.value.length > 0) searchLabel.style.opacity = '0';
    }
  });
});

},{}],26:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener('DOMContentLoaded', function () {
  var copy = document.querySelector('#copyToClipboard');
  var shareEmail = document.querySelector('#share-email');
  var shareSms = document.querySelector('#share-sms');
  var shareLinkContainer = document.querySelector('.share-links');
  if (!shareLinkContainer) return;
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (shareSms) {
    if (!isMobile || !navigator.share) {
      shareSms.style.display = 'none';
    }
  }
  if (copy) {
    copy.addEventListener('click', function (e) {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(function () {
        copy.innerText = 'Link Copied!';
        copy.classList.add('copied');
      });
    });
  }
  if (shareEmail) {
    shareEmail.addEventListener('click', function (e) {
      location.href = "mailto:?subject=" + encodeURIComponent(document.title) + "&body=" + encodeURIComponent(document.title + "\n" + window.location.href);
      e.preventDefault();
    });
  }
  if (shareSms) {
    shareSms.addEventListener('click', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              if (!navigator.share) {
                _context.next = 11;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return navigator.share({
                title: document.title,
                //text: "",
                url: window.location.href
              });
            case 5:
              _context.next = 9;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
            case 9:
              _context.next = 11;
              break;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 7]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});

},{}],27:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _player = _interopRequireDefault(require("@vimeo/player"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener('DOMContentLoaded', function () {
  var sendGTMEvent = function sendGTMEvent(eventAction, eventLabel) {
    var eventData = {
      'event': 'Video',
      'eventCategory': 'Video',
      eventAction: eventAction,
      eventLabel: eventLabel,
      'gtm.elementClasses': 'gtm-video'
    };
    window.dataLayer.push(eventData);
  };
  var videos = document.querySelectorAll('.video-block');
  if (videos.length === 0) return;
  videos.forEach(function (video) {
    var container = video.querySelector('.video-container');
    var videoEl = video.querySelector('video');
    var embedPlaceholder = video.querySelector('.embed-placeholder');
    var playButton = video.querySelector('.play-button');
    if (videoEl) {
      videoEl.addEventListener('loadedmetadata', function () {
        if (videoEl.videoWidth < videoEl.videoHeight) video.classList.add('iphone');
        container.style.paddingTop = videoEl.videoHeight / videoEl.videoWidth * 100 + '%';
      });
    } else {
      if (embedPlaceholder) {
        var embedHeight = parseInt(embedPlaceholder.getAttribute('data-embed-height'));
        var embedWidth = parseInt(embedPlaceholder.getAttribute('data-embed-width'));
        container.style.paddingTop = embedHeight / embedWidth * 100 + '%';
        if (embedWidth < embedHeight) video.classList.add('iphone');
      } else video.classList.add('reset-styles');
    }
    playButton.addEventListener('click', function () {
      var videoUrl = embedPlaceholder.getAttribute('data-embed-url');
      var videoId = videoUrl.split('/').pop();
      if (embedPlaceholder) embedPlaceholder.src = "https://player.vimeo.com/video/".concat(videoId);
      var player = new _player["default"](video);
      var videoSource = video.querySelector('iframe, video');
      player.on("loaded", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var videoTitle, highestWatch, milestone;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return player.getVideoTitle();
            case 2:
              videoTitle = _context2.sent;
              // Enable text tracks to autoplay when video starts
              player.enableTextTrack('en')["catch"](function (error) {
                // console.log('Text track error:', error);
              });
              highestWatch = 0;
              milestone = 0;
              player.on("play", function () {
                return sendGTMEvent('Play', videoTitle);
              });
              player.on("pause", function () {
                return sendGTMEvent('Pause', videoTitle);
              });
              setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var currentTime, totalTime, completionPercent;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return player.getCurrentTime();
                    case 2:
                      currentTime = _context.sent;
                      _context.next = 5;
                      return player.getDuration();
                    case 5:
                      totalTime = _context.sent;
                      completionPercent = currentTime / totalTime;
                      if (completionPercent > highestWatch) {
                        highestWatch = completionPercent;
                        if (highestWatch >= 0.25 && milestone < 0.25) {
                          sendGTMEvent("25%", videoTitle);
                          milestone = 0.25;
                        } else if (highestWatch >= 0.5 && milestone < 0.5) {
                          sendGTMEvent("50%", videoTitle);
                          milestone = 0.5;
                        } else if (highestWatch >= 0.75 && milestone < 0.75) {
                          sendGTMEvent("75%", videoTitle);
                          milestone = 0.75;
                        } else if (highestWatch >= 1 && milestone < 1) {
                          sendGTMEvent("watch to end", videoTitle);
                          milestone = 1;
                        }
                      }
                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })), 100);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
      var name = videoSource.getAttribute('title') ? videoSource.getAttribute('title') : 'Vimeo video';
      video.classList.remove('inactive');
      try {
        player.play();
        window.dataLayer.push({
          'event': "Video",
          'eventCategory': "Video",
          'eventAction': "Play",
          'eventLabel': name,
          'gtm.elementClasses': 'gtm-video'
        });
      } catch (error) {
        //log errors
        try {
          videoSource.play();
        } catch (error) {
          console.log(error);
        }
      }
    });
  });
});

},{"@vimeo/player":1}]},{},[16]);
